// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Translations for AR
 * @file translations.ar.js
 * @description Main application translations for ar
 * @version v3.1.0
 */

import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsAr = {
                'login.title': 'تسجيل الدخول',
                'login.slogan': 'محادثات بلا حدود!',
                'login.username': 'اسم المستخدم',
                'login.password': 'كلمة المرور',
                'login.submit': 'تسجيل الدخول',
                'login.loading': 'جاري التحميل...',
                'login.autoRegister.title': 'التسجيل التلقائي',
                'login.autoRegister.description': 'إذا لم يكن لديك حساب، أدخل اسم المستخدم وكلمة المرور. سيتم إنشاؤه تلقائياً.',
                'login.forgotPassword': 'نسيت كلمة المرور؟',
                'login.passwordRecovery.title': 'استعادة كلمة المرور',
                'login.passwordRecovery.description': 'أدخل بريدك الإلكتروني لتلقي رابط الاستعادة.',
                'login.passwordRecovery.emailLabel': 'البريد الإلكتروني',
                'login.passwordRecovery.emailPlaceholder': 'أدخل بريدك الإلكتروني',
                'login.passwordRecovery.emailHelp': 'سيتم إرسال رابط الاستعادة إلى بريدك الإلكتروني',
                'login.passwordRecovery.send': 'إرسال',
                'login.passwordRecovery.success': 'تم إرسال رابط الاستعادة إلى بريدك الإلكتروني. تحقق من صندوق الوارد.',
                'login.passwordRecovery.successTitle': 'تم إرسال البريد',
                'login.passwordRecovery.successMessage': 'أرسلنا لك بريداً يتضمن تعليمات إعادة تعيين كلمة المرور.\nتحقق من صندوق الوارد ومجلد البريد العشوائي. قد يستغرق وصول الرابط بضع دقائق.',
                'login.passwordRecovery.devExplanation': 'في وضع التطوير لا يُرسل البريد إلى صندوق الوارد؛ يُحفظ للمعاينة. استخدم «عرض البريد» لرؤية المحتوى ورابط الاستعادة.',
                'login.passwordRecovery.devSinkNotice': '⚠️ وضع التطوير: لم يُرسل هذا البريد إلى صندوق الوارد. استخدم «عرض البريد» لفتح الرسالة المُنشأة والرابط.',
                'login.passwordRecovery.invalidEmail': 'يرجى إدخال عنوان بريد إلكتروني صالح',
                'login.error.invalidPassword': 'كلمة مرور غير صالحة',
                'common.language': 'اللغة',
                'common.loading': 'جاري التحميل…',
                'common.back': 'رجوع',
                'common.backToStart': 'العودة للرئيسية',
                'common.continue': 'متابعة',
                'common.changeUser': 'تغيير المستخدم',
                'common.navigation': 'التنقل',
                'common.favorite': 'مفضل',
                'common.block': 'حظر',
                'common.user': 'مستخدم',
                'common.request_id_label': 'معرف الطلب',
                'app.install': 'تثبيت ArChat',
                'login.email.invalid': 'يرجى إدخال بريد إلكتروني صالح',
                'captcha.solve': 'يرجى حل التحقق بشكل صحيح',
                'captcha.refresh': 'إعادة توليد CAPTCHA',
                'captcha.generateError': 'خطأ في إنشاء التحقق. يرجى إعادة تحميل الصفحة.',
                'auth.require_email': 'البريد الإلكتروني مطلوب لإكمال التسجيل. يرجى إدخال بريدك.',
                'auth.invalid_credentials': 'اسم المستخدم أو كلمة المرور غير صحيحة.',
                'auth.account_blocked': 'الحساب غير نشط. أدخل بريدك الإلكتروني لإعادة التفعيل.',
                'auth.device_limit_reached': 'تم الوصول إلى حد الأجهزة. سجّل الخروج من جهاز آخر أو حدّث خطتك.',
                'auth.login.device_limit.title': 'تم بلوغ حد الجلسات أو الأجهزة',
                'auth.login.device_limit.body': 'تسمح خطتك بعدد محدود من الجلسات أو الأجهزة النشطة في الوقت نفسه. لتسجيل الدخول، سجّل الخروج من جهاز آخر أو أغلق جلسة نشطة أخرى، ثم أعد المحاولة.',
                'auth.password_incorrect': 'كلمة المرور غير صحيحة.',
                'auth.login.password_error_title': 'كلمة مرور غير صحيحة',
                'auth.login.password_attempts_hint': 'لديك 3 محاولات لإدخال كلمة المرور بشكل صحيح. إذا تجاوزتها، يجب عليك إعادة تعيين كلمة المرور.',
                'auth.login.password_attempts_exhausted_title': 'تم بلوغ حد المحاولات',
                'auth.login.password_attempts_exhausted_body': 'تجاوزت الحد المسموح وهو 3 محاولات. للمتابعة، أعد تعيين كلمة المرور من «هل نسيت كلمة المرور؟».',
                'auth.login.go_to_reset_password': 'الانتقال إلى إعادة التعيين',
                'auth.login.password_remaining_two': 'تبقى لك محاولتان.',
                'auth.login.password_remaining_one': 'تبقى لك محاولة واحدة.',
                'auth.login.password_attempts_locked_inline': 'لقد بلغت الحد الأقصى من المحاولات. يجب إعادة تعيين كلمة المرور.',
                'auth.account_inactive_email_mismatch': 'الحساب غير نشط والبريد الإلكتروني غير متطابق.',
                'auth.captcha_failed': 'التحقق غير صحيح. تحقق من إجابتك.',
                'auth.captcha_expired': 'انتهت صلاحية التحقق. تم إنشاء تحقق جديد تلقائياً.',
                'auth.unauthorized': 'ليس لديك صلاحية الوصول.',
                'auth.generic_error': 'حدث خطأ. يرجى المحاولة مرة أخرى.',
                'auth.method_not_allowed': 'الطريقة غير مسموح بها.',
                'auth.invalid_data': 'بيانات غير صالحة.',
                'auth.credentials_required': 'اسم المستخدم وكلمة المرور مطلوبان.',
                'auth.csrf_invalid': 'الجلسة غير صالحة. أعد تحميل الصفحة وحاول مرة أخرى.',
                'auth.username_taken': 'اسم المستخدم هذا مسجل بالفعل. سجل الدخول أو اختر غيره.',
                'auth.username_unavailable': 'اسم المستخدم هذا غير متاح.',
                'auth.nick_no_spaces': 'Nicknames cannot contain spaces.',
                'auth.password_too_short': 'كلمة المرور يجب أن تكون 6 أحرف على الأقل.',
                'auth.rate_limit': 'محاولات كثيرة. انتظر قليلاً وحاول مجدداً.',
                'auth.confirm_success': 'تم تأكيد الحساب بنجاح. جاري التحويل لتسجيل الدخول...',
                'auth.confirm_already_active': 'حسابك نشط بالفعل. يمكنك تسجيل الدخول.',
                'auth.reset_sent': 'إذا كان البريد مسجلاً، ستتلقى تعليمات إعادة تعيين كلمة المرور.',
                'auth.reset_token_invalid': 'رابط غير صالح أو مفقود.',
                'auth.reset_token_expired': 'انتهت صلاحية هذا الرابط. اطلب واحداً جديداً من "نسيت كلمة المرور؟".',
                'auth.reset_done': 'تم تحديث كلمة المرور. يمكنك تسجيل الدخول الآن.',
                'auth.reset_fatal': 'خطأ في الحفظ. يرجى المحاولة لاحقاً.',
                'auth.password_mismatch': 'كلمتا المرور غير متطابقتين.',
                'resetPassword.page.title': 'كلمة مرور جديدة',
                'resetPassword.page.description': 'أدخل كلمة المرور الجديدة (6 أحرف على الأقل).',
                'resetPassword.newPassword': 'كلمة المرور الجديدة',
                'resetPassword.newPasswordPlaceholder': '6 أحرف على الأقل',
                'resetPassword.submit': 'إعادة تعيين كلمة المرور',
                'resetPassword.success': 'تم تحديث كلمة المرور. جاري التوجيه إلى تسجيل الدخول...',
                'resetPassword.backToLogin': 'العودة إلى تسجيل الدخول',

                'account.delete.section_title': 'حذف الحساب',
                'account.delete.description': 'سيؤدي حذف حسابك إلى إزالة جميع بياناتك ورسائلك وجهات اتصالك وإعداداتك نهائياً. لا يمكن التراجع عن هذا الإجراء.',
                'account.delete.button': 'احذف حسابي',
                'accountDeletion.title': 'حذف الحساب والبيانات',
                'accountDeletion.description': 'اطلب حذف حساب ArChat والبيانات المرتبطة به.',
                'accountDeletion.openRequest': 'طلب حذف الحساب والبيانات',
                'account.delete.confirm_title': 'حذف الحساب',
                'account.delete.confirm_message': 'هل أنت متأكد أنك تريد حذف حسابك؟ سيتم إرسال بريد تأكيد إلى صندوق الوارد. الحذف نهائي ولا رجعة فيه.',
                'account.delete.email_sent_title': 'تم إرسال البريد',
                'account.delete.email_sent': 'أرسلنا لك بريد تأكيد. تحقق من صندوق الوارد وانقر على الرابط لتأكيد الحذف.',
                'account.delete.error': 'تعذر معالجة الطلب. حاول مرة أخرى.',
                'account.delete.confirm_page_title': 'تأكيد حذف الحساب',
                'account.delete.confirm_page_desc': 'أنت على وشك حذف حساب ArChat نهائياً. ستُزال جميع البيانات والرسائل وجهات الاتصال والإعدادات. لا يمكن التراجع عن هذا الإجراء.',
                'account.delete.confirm_final_button': 'نعم، احذف حسابي نهائياً',
                'account.delete.cancel_go_back': 'إلغاء والعودة',
                'account.delete.done_title': 'تم حذف الحساب',
                'account.delete.done_message': 'تم حذف حسابك بنجاح. تمت إزالة جميع البيانات.',
                'account.delete_token_expired': 'انتهت صلاحية رابط الحذف أو لم يعد صالحاً. اطلب رابطاً جديداً من ملفك الشخصي.',
                'account.delete_token_invalid': 'رابط حذف غير صالح أو مفقود.',
                'account.delete_email_failed': 'تعذر إرسال بريد التأكيد. حاول لاحقاً.',
                'account.delete_error': 'خطأ أثناء الحذف. حاول لاحقاً.',

                'auth.register_success_email_sent': 'تم إنشاء الحساب بنجاح. تم إرسال بريد التأكيد. تحقق من صندوق الوارد (ومجلد البريد العشوائي) وانقر على الرابط لتفعيل الحساب.',
                'auth.register_success_email_pending': 'تم إنشاء الحساب، لكن حدثت مشكلة عند إرسال بريد التأكيد. رمز التفعيل لا يزال صالحاً. تواصل مع المسؤول أو اطلب بريد تأكيد جديد.',
                'auth.email_not_verified': 'يجب تأكيد بريدك الإلكتروني لتفعيل الحساب.',
                'auth.email_not_verified_title': 'الحساب في انتظار التأكيد',
                'auth.email_send_failed': 'تعذر إرسال البريد. أعد المحاولة أو غيّر البريد.',
                'auth.email_send_failed_title': 'تعذر إرسال البريد',
                'auth.register.email_failed.title': 'تم إنشاء الحساب',
                'auth.register.email_failed.message': 'تم إنشاء حسابك بنجاح، لكن حدثت مشكلة في إرسال بريد التأكيد. تحقق من البريد العشوائي أو اطلب بريداً جديداً.',
                'auth.register.success.title': 'تم إنشاء الحساب',
                'auth.register.success.message': 'تم إنشاء الحساب بنجاح. تم إرسال بريد التأكيد. تحقق من صندوق الوارد (ومجلد البريد العشوائي) وانقر على الرابط لتفعيل الحساب.',
                'auth.resend_sent': 'تم إعادة إرسال بريد التأكيد.',
                'auth.resend_email': 'إعادة إرسال البريد',
                'auth.retry_resend': 'إعادة المحاولة',
                'auth.change_email': 'تغيير البريد',
                'auth.ver_email': 'عرض البريد',
                'auth.already_verified': 'الحساب مؤكد مسبقاً.',
                'auth.confirm_email_title': 'تأكيد البريد الإلكتروني',
                'auth.confirm_email_text': 'سيتم إرسال رابط التفعيل إلى:',
                'auth.confirm_email_edit': 'تعديل',
                'auth.confirm_email_confirm': 'تأكيد',
                'auth.confirm_email_typo_hint': 'هل تقصد ***@{suggestion}؟',
                'brand.slogan': 'قوة أن تكون مفهوماً مهما كانت اللغة',
                "brand.appName": "ArChat®",
                "brand.name": "ArChat®",
                "home.title": "ArChat®",
                'home.slogan': 'قوة أن تكون مفهوماً مهما كانت اللغة',
                'home.tagline': 'مراسلة مع ترجمة تلقائية',
                'home.login': 'تسجيل الدخول',
                'home.register': 'إنشاء حساب',
                'home.language': 'اللغة',
                'terms.title': 'الشروط والأحكام',
                'terms.accept': 'قبول والمتابعة',
                'terms.reject': 'رفض',
                'terms.rejectShort': 'لا أوافق',
                'terms.readAndAccept': 'لقد قرأت وأوافق على الشروط والأحكام',
                'terms.cancel': 'إلغاء',
                'register.pageTitle': 'إنشاء حساب',
                'register.pageSubtitle': 'أدخل بياناتك لإنشاء الحساب.',
                'register.submitLabel': 'إنشاء حساب',
                'register.confirm_title': 'تأكيد الحساب',
                'register.confirm_message': 'أنت على وشك إنشاء الحساب:',
                'register.confirm': 'تأكيد',
                'register.login_link': 'لديك حساب بالفعل؟',
                'register.password_hint': '6 أحرف على الأقل',
                'register.checking': 'جاري التحقق…',
                'register.username_taken': 'اسم المستخدم هذا مستخدم بالفعل.',
                'register.available': 'متاح',
                'register.emailAlreadyExists': 'هذا البريد الإلكتروني مسجل بالفعل.',
                'register.continue': 'متابعة',
                'login.demo.title': 'الوصول التجريبي',
                'login.demo.credentials': 'المستخدم: demo / كلمة المرور: demo',
                'captcha.label': 'التحقق من الأمان',
                'security.verification_title': 'التحقق من الأمان',
                'security.captcha_question': 'سؤال التحقق',
                'security.enter_answer': 'أدخل الإجابة',
                'captcha.description': 'حل العملية الرياضية للتحقق من أنك إنسان',
                'captcha.required': 'يجب إدخال إجابة CAPTCHA للمتابعة.',
                'menu.conversations': 'المحادثات',
                'menu.contacts': 'جهات الاتصال',
                'menu.dashboard': 'لوحة التحكم',
                'menu.profile': 'ملفي الشخصي',
                'menu.settings': 'الإعدادات',
                'menu.help': 'المساعدة',
                'menu.logout': 'تسجيل الخروج',
                'menu.files': 'ملفاتي',
                'reviews.menu_title': 'التقييمات',
                'reviews.rate_archat': 'قيّم ArChat',
                'reviews.my_review': 'تقييمي',
                'menu.open': 'القائمة',
                'navbar.contacts': 'جهات الاتصال',
                'navbar.profile': 'ملفي الشخصي',
                'navbar.settings': 'الإعدادات',
                'navbar.status': 'الحالة',
                'navbar.logout': 'تسجيل الخروج',
                'onboarding.welcome_title': 'مرحبًا بك في ArChat®',
                'onboarding.welcome_subtitle': 'تواصل مع أي شخص بأي لغة.',
                'onboarding.step1': 'الخطوة 1',
                'onboarding.step1_title': 'الخطوة 1',
                'onboarding.step1_description': 'ادعُ أول جهة اتصال لديك',
                'onboarding.step2': 'الخطوة 2',
                'onboarding.step2_title': 'الخطوة 2',
                'onboarding.step2_description': 'أرسل رسالتك الأولى',
                'onboarding.invite_contact': 'دعوة جهة اتصال',
                'onboarding.explore_archat': 'استكشاف ArChat®',
                'contacts.invite_contact': 'دعوة جهة اتصال',
                'contacts.no_contacts': 'لا توجد جهات اتصال',
                'help.view_initial_guide': 'عرض الدليل الأولي',
                'suggestions.title': 'اقتراحات',
                'suggestions.form.title': 'عنوان الاقتراح',
                'suggestions.form.message': 'صف فكرتك',
                'suggestions.form.submit': 'إرسال الاقتراح',
                'suggestions.send': 'إرسال الاقتراح',
                'suggestions.captcha_placeholder': 'النتيجة',
                'suggestions.cooldown': 'يجب الانتظار {minutes} دقيقة قبل إرسال اقتراح آخر.',
                'suggestions.success_title': 'تم إرسال الاقتراح',
                'suggestions.success_message': 'تم إرسال اقتراحك بنجاح. رقم المتابعة: {id}',
                'suggestions.success': 'شكراً لاقتراحك. سيقوم فريقنا بمراجعته.',
                'suggestions.success.title': 'شكراً لاقتراحك!',
                'suggestions.success.reference': 'المرجع',
                'suggestions.success.review': 'سيقوم فريقنا بمراجعة فكرتك.',
                'suggestions.success.email': 'أرسلنا لك أيضاً بريداً إلكترونياً للتأكيد.',
                'suggestions.success.copy': 'نسخ',
                'suggestions.success.copied': 'تم نسخ المرجع',
                'suggestions.form.required': 'العنوان والرسالة مطلوبان.',
                'suggestions.error': 'تعذر الإرسال. يرجى المحاولة مرة أخرى.',
                'profile.title': 'ملفي الشخصي',
                'profile.founderBadge': 'المؤسس #{position}/{limit}',
                'profile.founderTooltip': 'عضو مؤسس – سعر مجمد مدى الحياة طالما الاشتراك نشط',
                'profile.founderMember': 'عضو مؤسس',
                'profile.founderHeaderBadge': '★ مؤسس #{position}/150',
                'profile.camera.access_denied': 'تعذر الوصول إلى الكاميرا. تحقق من الأذونات.',
                'profile.edit': 'تعديل',
                'profile.save': 'حفظ التغييرات',
                'profile.save.success': 'تم تحديث ملفك الشخصي بنجاح.',
                'profile.save.success.title': 'تم تحديث الملف الشخصي',
                'profile.update.success.title': 'تم تحديث الملف الشخصي',
                'profile.update.success.message': 'تم حفظ التغييرات.',
                'profile.save.error': 'تعذر تحديث الملف الشخصي. يرجى المحاولة مرة أخرى.',
                'profile.save.error.title': 'خطأ في الحفظ',
                'profile.cancel': 'إلغاء',
                'profile.nick': 'اسم المستخدم',
                'profile.nick.help': 'معرفك الفريد في النظام',
                'profile.name': 'الاسم',
                'profile.lastname': 'اسم العائلة',
                'profile.alias': 'الاسم المستعار',
                'profile.email': 'البريد الإلكتروني',
                'profile.phone': 'الهاتف',
                'profile.language': 'اللغة',
                'profile.country': 'البلد',
                'profile.country.select': 'اختر البلد',
                'profile.biography': 'السيرة الذاتية',
                'bio.modal.original': 'الأصل',
                'bio.modal.translation': 'الترجمة',
                'bio.modal.empty': 'لا توجد سيرة ذاتية لهذا الاتصال.',
                'bio.modal.translating': 'جارٍ الترجمة...',
                'bio.modal.translation_error': 'تعذر ترجمة السيرة الذاتية.',
                'attachment.unnamed_file': 'ملف',
                'auth.login_error.default_title': 'خطأ في الوصول',
                'auth.login_error.default_message': 'تعذر تسجيل الدخول.',
                'profile.photo': 'صورة الملف الشخصي',
                'notifications.bell.aria': 'الإشعارات',
                'notifications.panel.title': 'الإشعارات',
                'notifications.empty': 'لا توجد إشعارات',
                'notifications.mark_read': 'تعليم كمقروء عند الفتح',
                'billing.change_plan': 'تغيير الخطة',
                'billing.usage.title': 'استخدام الخطة',
                'billing.usage.users': 'المستخدمون',
                'billing.usage.messages': 'الرسائل (اليوم)',
                'billing.usage.invitations': 'الدعوات (اليوم)',
                'billing.usage.messages_month': 'الرسائل هذا الشهر',
                'billing.usage.chats': 'المحادثات',
                'billing.usage.warning': 'أنت تقترب من حد خطتك. ترقية إلى PRO لمزيد من السعة.',
                'plans.limit.reached': 'تم بلوغ الحد — ترقية الخطة',
                'profile.theme.dark': 'الوضع الداكن',
                'profile.theme.light': 'الوضع الفاتح',
                'profile.theme.argentina': 'مظهر الأرجنتين',
                'modal.title': 'العنوان',
                'modal.success.title': 'نجاح',
                'modal.error.title': 'خطأ',
                'modal.warning.title': 'تحذير',
                'info.title': 'معلومات',
                'appearance.title': 'المظهر',
                'appearance.theme.light': 'فاتح',
                'appearance.theme.dark': 'داكن',
                'theme.title': 'المظهر',
                'theme.light': 'فاتح',
                'theme.dark': 'داكن',
                'profile.photo.section': 'صورة الملف الشخصي',
                'profile.personalInfo': 'المعلومات الشخصية',
                'profile.preferences': 'التفضيلات',
                'profile.country.help': 'سيتم تعيين المنطقة الزمنية تلقائياً وفقاً للبلد المحدد',
                'profile.lastname.placeholder': 'اسم عائلتك (اختياري)',
                'profile.name.placeholder': 'اسمك (اختياري)',
                'profile.biography.placeholder': 'أخبرنا عن نفسك...',
                'profile.notifications.sound': 'صوت الإشعارات',
                'profile.notifications.sound_desc': 'تشغيل الصوت عند وصول رسائل أو تنبيهات مهمة',
                'profile.plan.title': 'خطة الاشتراك',
                'profile.plan.current': 'خطتك الحالية',
                'profile.plan.expires': 'تاريخ الانتهاء',
                'profile.plan.free.description': 'خطة مجانية مع وظائف محدودة. قم بالترقية إلى PRO للاستمتاع بجميع الميزات دون قيود.',
                'profile.plan.pro.description': 'ممتاز! لديك وصول كامل لجميع الميزات المميزة لـ ArChat®.',
                'profile.plan.upgrade.button': 'الترقية إلى PRO',
                'profile.plan.upgrade.hint': 'الوصول إلى جميع الميزات بدون قيود',
                'profile.photo.change': 'تغيير صورة الملف الشخصي',
                'message.placeholder': 'اكتب رسالة...',
                'message.placeholderWithFile': 'إرسال الملف',
                "message.sent_from_country": "مرسل من",
                "message.sent_at_local_time": "التوقيت المحلي للمصدر",
                "message.timezone_label": "المنطقة الزمنية",
                "message.context_info": "تحافظ هذه الرسالة على السياق الزمني للوقت الذي تم إرسالها فيه.",
                "message.context_pro_hint": "تحتوي هذه الرسالة على سياق زمني وجغرافي متاح في الخطط الاحترافية.",
                "message.context_pro_badge": "السياق برو",
                'message.new': 'رسالة جديدة',
                'message.edit': 'تعديل الرسالة',
                'message.edit.save': 'حفظ التعديل',
                'message.edit.cancel': 'إلغاء التعديل',
                'message.translating': 'جاري الترجمة...',
                'message.translation_failed': 'تعذرت الترجمة',
                'message.not_translated': 'النص الأصلي',
                'message.retry_send': 'إعادة المحاولة',
                'message.retrying': 'جاري إعادة المحاولة...',
                'message.delete': 'حذف الرسالة',
                'message.deleted_placeholder': 'تم حذف الرسالة',
                'message.edited': 'تم التعديل',
                'message.edited_at': 'تم التعديل في',
                'message.delete_for_me.tooltip': 'حذف لي',
                'message.delete_for_me.aria': 'حذف هذه الرسالة لي فقط',
                'message.delete_for_me.confirm_title': 'حذف الرسالة',
                'message.delete_for_me.confirm_message': 'سيتم حذف هذه الرسالة من عرضك فقط.',
                'message.delete_for_everyone.tooltip': 'حذف للجميع',
                'message.delete_for_everyone.aria': 'حذف هذه الرسالة لجميع المشاركين',
                'message.delete_for_everyone.confirm_title': 'حذف الرسالة للجميع',
                'message.delete_for_everyone.confirm_message': 'سيتم حذف هذه الرسالة لك وللمشارك الآخر.',
                'message.delete_for_everyone.window_expired': 'انتهت مهلة الحذف',
                'message.translation.show': 'عرض الأصل والترجمة',
                'message.translation.hide': 'إخفاء الترجمة',
                'emoji.search': 'ابحث عن إيموجي',
                'emoji.close': 'إغلاق المنتقي',
                'presence.unavailable': 'الحالات غير متاحة',
                'presence.maintenance': 'الخادم تحت الصيانة',
                'home.access_nav': 'الوصول إلى التطبيق',
                'message.audio.transcribe': 'تفريغ الصوت',
                'message.audio.transcribing': 'جارٍ التفريغ...',
                'message.audio.transcription': 'التفريغ',
                'message.audio.error': 'تعذر تفريغ الصوت',
                'attachment.title': 'إرفاق ملف',
                'attachment.close': 'إغلاق',
                'attachment.gallery': 'معرض الصور/الفيديو',
                'attachment.cameraFront': 'الكاميرا الأمامية',
                'attachment.cameraBack': 'الكاميرا الخلفية',
                'attachment.cameraWeb': 'كاميرا الويب',
                'attachment.recordAudio': 'تسجيل الصوت بالميكروفون',
                'attachment.selectFile': 'اختر ملف (صوت، فيديو، نص، PDF)',
                'attachment.remove': 'إزالة',
                'attachments.recipientFreeBlocked.title': 'حد الخطة',
                'attachments.recipientFreeBlocked.sender': 'المستخدم لديه خطة Free ولا يمكنه استلام المرفقات.',
                'attachments.recipientFreeBlocked.receiver': 'حاول {senderName} إرسال مرفق، لكن خطة {planName} لا تسمح باستلام المرفقات. نوصي بالترقية لاستلام الملفات.',
                'attachments.recipientFreeBlocked.upgradeCta': 'ترقية الخطة',
                'audio.title': 'تسجيل الصوت',
                'audio.close': 'إغلاق',
                'audio.ready': 'جاهز للتسجيل',
                'audio.recording': 'جاري التسجيل...',
                'audio.finished': 'اكتمل التسجيل',
                'audio.start': 'بدء التسجيل',
                'audio.stop': 'إيقاف التسجيل',
                'audio.confirm': 'تأكيد وإرسال',
                'audio.rerecord': 'إعادة التسجيل',
                'audio.error.microphone': 'تعذر الوصول إلى الميكروفون. تحقق من الأذونات.',
                'camera.title': 'الكاميرا',
                'camera.close': 'إغلاق',
                'camera.switch': 'تبديل الكاميرا',
                'camera.capture': 'التقاط صورة',
                'camera.loading': 'بدء تشغيل الكاميرا...',
                'camera.retry': 'إعادة المحاولة',
                'camera.error.access': 'تعذر الوصول إلى الكاميرا. تحقق من الأذونات.',
                'camera.error.permission': 'تم رفض أذونات الكاميرا. يرجى السماح بالوصول إلى الكاميرا في إعدادات المتصفح.',
                'camera.error.notFound': 'لم يتم العثور على كاميرا.',
                'camera.error.busy': 'الكاميرا مستخدمة من قبل تطبيق آخر.',
                'camera.error.constraint': 'لا يمكن تلبية قيود الكاميرا.',
                'profile.photo.take': 'التقاط صورة',
                'profile.photo.gallery': 'اختر من المعرض',
                'profile.photo.uploading': 'جاري رفع الصورة...',
                'profile.photo.upload.success': 'تم تحديث صورة الملف الشخصي بنجاح',
                'profile.photo.upload.success.title': 'تم تحديث الصورة',
                'profile.photo.upload.error': 'حدث خطأ أثناء رفع صورة الملف الشخصي. يرجى المحاولة مرة أخرى.',
                'profile.photo.upload.error.title': 'خطأ في الرفع',
                'user.default': 'المستخدم',
                'logout.title': 'تأكيد',
                'logout.confirm': 'هل أنت متأكد من أنك تريد تسجيل الخروج?',
                'contacts.title': 'جهات الاتصال',
                'contacts.search': 'بحث جهة اتصال',
                'contacts.search.placeholder': 'البحث عن طريق اسم المستخدم، الاسم، اسم العائلة، البلد أو اللغة...',
                'contacts.sort': 'ترتيب',
                'contacts.sortByName': 'حسب الاسم',
                'contacts.sortByStatus': 'حسب الحالة',
                'contacts.sortByRecent': 'الأحدث',
                'contacts.filter': 'تصفية',
                'contacts.filterAll': 'الكل',
                'contacts.filterAvailable': 'المتاحون',
                'contacts.filterInvited': 'المدعوون',
                'contacts.filterBlocked': 'المحظورون',
                'contacts.pending_invitations': 'الدعوات المعلقة',
                'contacts.status.invitation_sent': 'تم إرسال الدعوة',
                'contacts.empty': 'لا توجد جهات اتصال',
                'contacts.empty.title': 'ليس لديك جهات اتصال بعد',
                'contacts.empty.message': 'ادعُ جهة اتصال أو أضف واحدة للبدء في الدردشة.',
                'contacts.empty.invite_button': 'دعوة جهة اتصال',
                'contacts.empty.private.message': 'ملفك الشخصي خاص. ادعُ جهات اتصال للبدء في الدردشة.',
                'contacts.empty.private.invite_button': 'دعوة جهة اتصال',
                'contacts.search.no_results': 'لم يتم العثور على جهات اتصال',
                'contacts.search.clear': 'عرض الكل',
                'contacts.controls.search_placeholder': 'ابحث عن جهة اتصال...',
                'contacts.controls.search_label': 'بحث جهة اتصال',
                'contacts.controls.sort_label': 'ترتيب حسب',
                'contacts.controls.sort.name': 'الاسم',
                'contacts.controls.sort.status': 'الحالة',
                'contacts.controls.sort.recent': 'الأحدث',
                'contacts.controls.sort.manual': 'يدوي',
                'contacts.controls.sort.manual_drag_hint': 'اسحب لإعادة الترتيب',
                'contacts.controls.filter_label': 'الحالة',
                'contacts.controls.filter.all': 'الكل',
                'contacts.controls.filter.available': 'المتاحون',
                'contacts.controls.filter.invited': 'المدعوون',
                'contacts.controls.filter.blocked': 'المحظورون',
                'contacts.controls.filter.favorites': 'المفضلة',
                'contacts.controls.hide_non_favorites': 'إخفاء جهات الاتصال غير المفضلة',
                'contacts.controls.show_all': 'إظهار كل جهات الاتصال',
                'contacts.nick': 'اسم المستخدم',
                'contacts.name': 'الاسم',
                'contacts.lastname': 'اسم العائلة',
                'contacts.country': 'البلد',
                'contacts.language': 'اللغة',
                'contacts.status': 'الحالة',
                'status.available': 'متاح',
                'status.busy': 'مشغول',
                'status.in_call': 'في مكالمة',
                'status.away': 'بعيد',
                'status.offline': 'غير متصل',
                'status.custom': 'رسالة مخصصة',
                'status.set_title': 'حالة التوفر',
                'status.set_button': 'تغيير الحالة',
                'status.placeholder': 'رسالة اختيارية (مثل: في اجتماع)',
                'contacts.status.pending_registration': 'في انتظار التسجيل',
                'contacts.status.registered': 'مدعو - مسجّل',
                'contacts.status.ready_to_chat': 'جاهز للمحادثة',
                'contacts.status.active_conversation': 'محادثة نشطة',
                'contacts.invitation.pending.title': 'دعوة معلقة',
                'contacts.invitation.pending.message': 'هذه الدعوة في انتظار التسجيل. سيستلم جهة الاتصال بريدًا إلكترونيًا لإكمال التسجيل. بمجرد التسجيل، يمكنك الدردشة معهم.',
                'contacts.error.no_registered': 'جهة الاتصال غير مسجلة بعد. انتظر حتى يكملوا التسجيل.',
                'contact.edit.title': 'تعديل جهة الاتصال',
                'contact.edit.alias.label': 'اسم مستعار مخصص',
                'contact.edit.alias.placeholder': 'مثال: جون من العمل',
                'contact.edit.alias.help': 'سيظهر هذا الاسم بدلاً من الاسم الحقيقي',
                'contact.edit.nota.label': 'ملاحظة شخصية',
                'contact.edit.nota.placeholder': 'أضف ملاحظة حول جهة الاتصال هذه...',
                'contact.edit.nota.help': 'ملاحظات خاصة مرئية لك فقط',
                'contact.edit.error.noUser': 'خطأ: لم يتم التعرف على المستخدم',
                'contact.edit.error.noContactId': 'خطأ: تعذر التعرف على جهة الاتصال',
                'contact.edit.error.save': 'خطأ في الحفظ',
                'contact.limit.title': 'تم الوصول إلى الحد الأقصى لجهات الاتصال',
                'contact.limit.message': 'تسمح خطة FREE بحد أقصى جهتي اتصال لكل مستخدم. ترقية إلى FOUNDATION أو PRO لمزيد من السعة عند تفعيل الفوترة.',
                'contact.edit.info.personalized': 'هذه التغييرات مخصصة لك فقط ولا تؤثر على المستخدمين الآخرين.',
                'contact.edit.profileInfo': 'معلومات الملف الشخصي',
                'export.title': 'تصدير المحادثة',
                'export.description': 'اختر التنسيق الذي تريد تصدير هذه المحادثة به:',
                'export.progress': 'جاري التصدير...',
                "export.format.pdf": "قوات الدفاع الشعبي",
                'export.format.pdf.description': 'مستند PDF مع جميع الصور والملفات',
                "export.format.html": "أتش تي أم أل",
                'export.format.html.description': 'ملف HTML يمكنك فتحه في أي متصفح',
                'export.info': 'سيشمل التصدير جميع الرسائل والصور والملفات من هذه المحادثة.',
                'export.pro_required.title': 'تصدير المحادثة',
                'export.pro_required.message': 'هذه الميزة متاحة في خطة PRO.',
                'invitation.title': 'دعوة جهة اتصال عبر البريد الإلكتروني',
                'invitation.modal.title': 'إرسال دعوة',
                'invitation.modal.description': 'ادعُ شخصًا للدردشة معك على ArChat®. سيستلم بريدًا إلكترونيًا يحتوي على رابط لقبول الدعوة.',
                'invitation.email.label': 'بريد المدعو',
                "invitation.email.placeholder": "ejemplo@email.com",
                'invitation.email.required': 'البريد الإلكتروني مطلوب',
                'invitation.email.invalid': 'يرجى إدخال بريد إلكتروني صالح',
                'invitation.language.label': 'اللغة المفضلة للمدعو',
                'invitation.language.help': 'سيتم إرسال البريد الإلكتروني بهذه اللغة',
                'invitation.mode.label': 'وضع المحادثة',
                'invitation.mode.profesional': 'احترافي',
                'invitation.mode.profesional.description': 'محادثة رسمية واحترافية',
                'invitation.mode.tecnico': 'تقني',
                'invitation.mode.tecnico.description': 'محادثة تقنية ومتخصصة',
                'invitation.mode.casual': 'عادي',
                'invitation.mode.casual.description': 'محادثة غير رسمية وودية',
                'invitation.message.label': 'رسالة شخصية (اختياري)',
                'invitation.message.placeholder': 'اكتب رسالة شخصية للمدعو...',
                'invitation.send': 'إرسال الدعوة',
                'invitation.sending': 'جاري الإرسال...',
                'invitation.success': 'تم إرسال الدعوة بنجاح',
                'invitation.error': 'خطأ في إرسال الدعوة',
                'invitation.error.self': 'لا يمكنك دعوة نفسك',
                'invitation.error.duplicate': 'دعوة معلقة موجودة بالفعل لهذا البريد الإلكتروني',
                'invitation.list.title': 'الدعوات المرسلة',
                'invitation.list.empty': 'لم ترسل أي دعوات',
                'invitation.list.email': 'البريد الإلكتروني',
                'invitation.list.language': 'اللغة',
                'invitation.list.mode': 'الوضع',
                'invitation.list.status': 'الحالة',
                'invitation.list.created': 'تم الإرسال',
                'invitation.list.expires': 'ينتهي',
                'invitation.list.actions': 'الإجراءات',
                'invitation.status.pending': 'معلق',
                'invitation.status.accepted': 'مقبول',
                'invitation.status.expired': 'منتهي الصلاحية',
                'invitation.status.cancelled': 'ملغي',
                'invitation.copy.link': 'نسخ الرابط',
                'invitation.copy.success': 'تم نسخ الرابط إلى الحافظة',
                'invitation.cancel': 'إلغاء',
                'invitation.cancel.confirm': 'هل أنت متأكد من إلغاء هذه الدعوة؟',
                'invitation.cancel.success': 'تم إلغاء الدعوة بنجاح',
                'invitation.cancel.title': 'تأكيد الإلغاء',
                'invitation.resend': 'إعادة إرسال البريد الإلكتروني',
                'invitation.resend.title': 'إعادة إرسال الدعوة',
                'invitation.resend.success': 'تم إعادة إرسال بريد الدعوة بنجاح',
                'invitation.resend.error': 'خطأ في إعادة إرسال بريد الدعوة',
                'invitation.accept.title': 'قبول الدعوة',
                'invitation.accept.description': 'تمت دعوتك للدردشة على ArChat®',
                'invitation.accept.inviter': 'دعوة من',
                'invitation.accept.message': 'رسالة شخصية',
                'invitation.accept.login': 'تسجيل الدخول',
                'invitation.accept.register': 'التسجيل',
                'invitation.accept.error.invalid': 'رمز دعوة غير صالح',
                'invitation.accept.error.expired': 'انتهت صلاحية هذه الدعوة',
                'invitation.accept.error.accepted': 'تم قبول هذه الدعوة بالفعل',
                'invitation.accept.error.cancelled': 'تم إلغاء هذه الدعوة',
                'invitation.accept.error.email_mismatch': 'بريد حسابك الإلكتروني لا يطابق بريد الدعوة',
                'invitation.accept.success': 'تم قبول الدعوة. جاري إعادة التوجيه إلى الدردشة...',
                'invitations.sent.title': 'الدعوات المرسلة',
                'invitations.sent.empty': 'لا توجد دعوات معلقة',
                'invitations.pending.title': 'الدعوات المعلقة',
                'invitations.columns.email': 'البريد الإلكتروني',
                'invitations.columns.language': 'اللغة',
                'invitations.columns.mode': 'الوضع',
                'invitations.columns.status': 'الحالة',
                'invitations.columns.sentAt': 'أُرسلت',
                'invitations.columns.actions': 'إجراءات',
                'invitations.status.pending': 'معلقة',
                'invitations.status.accepted': 'مقبولة',
                'invitations.status.cancelled': 'ملغاة',
                'invitations.status.expired': 'منتهية',
                'invitations.actions.cancel': 'إلغاء',
                'invitations.actions.copy': 'نسخ الرابط',
                'invitations.actions.resend': 'إعادة إرسال البريد',
                'profile.privacy.title': 'الخصوصية',
                'profile.privacy.public_visibility': 'جعل ملفي الشخصي مرئياً للعامة',
                'profile.privacy.public_warning': 'هذا يسمح لأي مستخدم في ArChat® بالعثور عليك وبدء محادثة.',
                'profile.privacy.private_info': 'ملفك الشخصي خاص. فقط المستخدمون الذين تدعوهم أو الذين يدعونك يمكنهم الدردشة معك.',
                'profile.privacy.private_default': 'افتراضياً، ملفك الشخصي خاص لمزيد من الأمان.',
                'common.close': 'إغلاق',
                'common.cancel': 'إلغاء',
                'common.confirm': 'تأكيد',
                'common.sending': 'جاري الإرسال',
                'common.save': 'حفظ',
                'common.saving': 'جاري الحفظ...',
                'buttons.accept': 'قبول',
                'buttons.cancel': 'إلغاء',
                'buttons.save': 'حفظ',
                'buttons.edit': 'تعديل',
                'buttons.retry': 'إعادة المحاولة',
                'buttons.confirm': 'تأكيد',
                'buttons.yes': 'نعم',
                'buttons.no': 'لا',
                'buttons.send': 'إرسال',
                'buttons.close': 'إغلاق',
                'buttons.continue': 'متابعة',
                'buttons.delete': 'حذف',
                'buttons.logout': 'تسجيل الخروج',
                'buttons.back': 'رجوع',
                'buttons.update': 'تحديث',
                'buttons.upload': 'رفع',
                'buttons.select': 'اختيار',
                'conversation.backToContacts': 'العودة إلى جهات الاتصال',
                'help.title': 'مساعدة ArChat®',
                'help.what.title': 'ما هو ArChat®?',
                'help.what.description': 'ArChat® هو نظام مراسلة فورية مع ترجمة تلقائية يسمح لك بالتواصل مع المستخدمين من جميع أنحاء العالم بلغتك المفضلة. يكتب كل مستخدم بلغته ويتلقى الرسائل مترجمة تلقائياً إلى لغته.',
                'help.how.title': 'كيف يعمل?',
                'help.how.step1.title': 'تسجيل الدخول',
                'help.how.step1.description': 'استخدم اسم المستخدم وكلمة المرور للوصول إلى النظام. إذا لم يكن لديك حساب، سيتم إنشاؤه تلقائياً.',
                'help.how.step2.title': 'استكشف جهات الاتصال',
                'help.how.step2.description': 'انتقل إلى قسم "جهات الاتصال" لرؤية جميع المستخدمين المتاحين. يمكنك البحث بالاسم، البلد أو اللغة.',
                'help.how.step3.title': 'ابدأ محادثة',
                'help.how.step3.description': 'انقر على حالة جهة اتصال أو اسمها لبدء محادثة. سيقوم النظام بترجمة الرسائل تلقائياً.',
                'help.how.step4.title': 'اكتب وأرسل',
                'help.how.step4.description': 'اكتب رسالتك بلغتك المفضلة. سيستلم المستلم الرسالة مترجمة تلقائياً إلى لغته.',
                'help.features.title': 'الميزات الرئيسية',
                'help.features.translation': '🌐 ترجمة تلقائية وفورية بين اللغات',
                'help.features.status': '💬 حالة الحضور (متصل، غير نشط، لا تزعج، إلخ)',
                'help.features.statusCustom': '💬 حالات مخصصة مع رمز تعبيري ورسالة مخصصة',
                'help.features.contacts': '👥 قائمة جهات اتصال كاملة مع البحث والمرشحات',
                'help.features.contactsMobile': '📱 عرض محمول محسّن مع معلومات كاملة (اسم العائلة، البلد، الحالة)',
                'help.features.contactsFilter': '👁️ زر لإظهار/إخفاء جهات الاتصال غير المفضلة - يقلل القائمة إلى المفضلة فقط',
                'help.features.contactAlias': '✏️ اسم مستعار مخصص وملاحظات خاصة لكل جهة اتصال - انقر على اسم جهة الاتصال في المحادثة',
                'help.features.themes': '🎨 سمتان متاحتان: الأرجنتين (أزرق فاتح/أبيض/ذهبي)، داكن (بنفسجي عميق)',
                'help.features.messages': '📨 مراسلة فورية مع مؤشرات القراءة',
                'help.features.attachments': '📎 إرفاق الملفات: الصور، الفيديو، الصوت ومستندات PDF',
                'help.features.camera': '📸 التقاط الصور بكاميرا أمامية، خلفية أو كاميرا ويب',
                'help.features.gallery': '🖼️ اختيار الملفات من المعرض',
                'help.features.compression': '🗜️ ضغط الصور تلقائياً وإنشاء صور مصغرة',
                'help.features.progress': '📊 شريط التقدم أثناء تحميل الملفات',
                'help.features.delete': '🗑️ حذف رسائلك الخاصة',
                'help.features.scroll': '⬇️ التمرير التلقائي إلى آخر رسالة عند فتح المحادثة',
                'help.features.profile': '👤 ملف شخصي قابل للتخصيص مع صورة رمزية، سيرة ذاتية وتفضيلات',
                'help.features.profileEdit': '✏️ تعديل الملف الشخصي دون انقطاع (لا يتم التحديث أثناء التعديل)',
                'help.features.countries': '🌍 قائمة كاملة بأكثر من 195 دولة مع اختيار المنطقة الزمنية تلقائياً',
                'help.features.registration': '📧 التسجيل مع تأكيد البريد الإلكتروني وCAPTCHA الأمنية',
                'help.features.multilanguage': '🗣️ دعم لعدة لغات (الإسبانية، الإنجليزية، البرتغالية، الفرنسية، الألمانية، الإيطالية، الروسية، الصينية، اليابانية، الكورية، العربية، الهندية)',
                'help.features.audio': '🎤 تسجيل رسائل صوتية مع نسخ تلقائي إلى نص',
                'help.features.speechToText': '📝 نسخ الصوت إلى نص باستخدام Whisper و Google Speech API',
                'help.features.pwa': '📲 تطبيق PWA قابل للتثبيت على الأجهزة المحمولة وسطح المكتب',
                'help.features.sync': '🔄 مزامنة تلقائية للرسائل كل 5 ثوانٍ',
                'help.features.deleteSync': '🗑️ مزامنة تلقائية للرسائل المحذوفة عبر الأجهزة',
                'help.features.notifications': '🔔 إشعارات صوتية عند استلام رسائل جديدة',
                'help.features.retranslation': '🔄 إعادة ترجمة تلقائية للرسائل إذا فشلت المحاولة الأولى',
                'help.features.preview': '👁️ معاينة الملفات قبل الإرسال',
                'help.features.security': '🔒 نظام أمان مع CAPTCHA وبصمة المتصفح وحد معدل',
                'help.features.passwordRecovery': '🔑 استعادة كلمة المرور عبر البريد الإلكتروني',
                'help.features.emailConfirmation': '📧 تأكيد الحساب عبر البريد الإلكتروني مع رابط التفعيل',
                'help.features.invitations': '📧 دعوات بريد إلكتروني خاصة - ادع جهات اتصال خارجية بلغة وسياق محددين',
                'help.features.invitationsManagement': '📋 إدارة كاملة للدعوات - قائمة، إعادة إرسال أو إلغاء الدعوات المعلقة من القائمة',
                'help.features.contactStatus': '🏷️ حالة جهة الاتصال المرئية - انظر حالة كل جهة اتصال (معلقة، مسجلة، جاهزة للدردشة)',
                'help.features.favorites': '⭐ نظام المفضلة - ضع علامة على جهات الاتصال كمفضلة للوصول السريع',
                'help.features.profilePhoto': '📸 تحسين رفع صورة الملف الشخصي - اختر الصور من المعرض مع معاينة فورية',
                'help.features.translationSender': '👁️ عرض الترجمة للمرسل - انظر كيف تمت ترجمة رسالتك إلى لغة المستلم',
                'help.features.unifiedContacts': '🔗 نموذج جهات الاتصال الموحد - يتم اشتقاق جهات الاتصال من الدعوات والمحادثات الموجودة',
                'help.features.privacy': '🔒 الوضع الخاص افتراضيًا - ملفك الشخصي خاص ويمكن الوصول إليه فقط من خلال دعوة مباشرة',
                'help.features.export': '💾 تصدير المحادثات - قم بتصدير المحادثات الكاملة إلى PDF أو HTML مع الصور والملفات',
                'help.tips.title': 'نصائح مفيدة',
                'help.tips.language': '✅ قم بتعيين لغتك المفضلة في ملفك الشخصي لتلقي رسائل مترجمة بشكل صحيح',
                'help.tips.status': '✅ قم بتحديث حالة الحضور الخاصة بك حتى يعرف الآخرون تواجدك',
                'help.tips.statusCustom': '✅ أنشئ حالات مخصصة مع رمز تعبيري ورسالة للتعبير عن حالتك الحالية',
                'help.tips.search': '✅ قم بتمييز المفضلة (نجمة) وحظر المستخدمين من نافذة "المستخدمون"',
                'help.tips.contactsFilter': '✅ استخدم زر العين (👁️) في الشريط العلوي لإظهار أو إخفاء جهات الاتصال التي ليست مفضلة',
                'help.tips.contactAlias': '✅ انقر على اسم جهة الاتصال في المحادثة لإضافة اسم مستعار مخصص وملاحظات خاصة',
                'help.tips.avatar': '✅ انقر على صورة رمزية لجهة اتصال لرؤية صورتها بحجم كبير',
                'help.tips.messages': '✅ رمز ArChat® يومض عندما يكون لديك رسائل غير مقروءة',
                'help.tips.attachments': '✅ أرفق الصور، الفيديو، الصوت أو PDF باستخدام زر المشبك (📎)',
                'help.tips.camera': '✅ استخدم الكاميرا لالتقاط الصور مباشرة من التطبيق',
                'help.tips.compression': '✅ يتم ضغط الصور تلقائياً لتوفير المساحة',
                'help.tips.delete': '✅ يمكنك حذف رسائلك الخاصة بالنقر على زر الحذف',
                'help.tips.profile': '✅ عدّل ملفك الشخصي دون قلق: النظام لا يتم تحديثه أثناء التعديل',
                'help.tips.themes': '✅ غيّر السمة من الإعدادات > المظهر: الأرجنتين (أزرق فاتح)، داكن (بنفسجي عميق)',
                'help.tips.country': '✅ اختر بلدك في الملف الشخصي ليتم تكوين المنطقة الزمنية تلقائياً',
                'help.tips.registration': '✅ عند التسجيل، تحقق من بريدك الإلكتروني لتفعيل حسابك بالكامل',
                'help.tips.audio': '✅ سجل رسائل صوتية باستخدام زر الميكروفون (🎤) - سيتم نسخها تلقائياً إلى نص',
                'help.tips.install': '✅ قم بتثبيت ArChat® كتطبيق PWA على جهازك للوصول السريع من سطح المكتب',
                'help.tips.sync': '✅ الرسائل تتم مزامنتها تلقائياً كل 5 ثوانٍ - لا حاجة للتحديث',
                'help.tips.deleteSync': '✅ إذا قمت بحذف رسالة، سيتم حذفها تلقائياً على جميع أجهزة المستلم',
                'help.tips.notifications': '✅ ستسمع صوتاً عند استلام رسالة جديدة من مستخدم آخر',
                'help.tips.retranslation': '✅ إذا لم يتم ترجمة الرسالة بشكل صحيح، ستحاول النظام إعادة ترجمتها تلقائياً',
                'help.tips.preview': '✅ قم بمعاينة الملف قبل الإرسال للتأكد من أنه الصحيح',
                'help.tips.passwordRecovery': '✅ إذا نسيت كلمة المرور، استخدم رابط "نسيت كلمة المرور؟" عند تسجيل الدخول',
                'help.tips.emailConfirmation': '✅ تحقق من بريدك الإلكتروني بعد التسجيل واضغط على رابط التأكيد',
                'help.tips.languageChange': '✅ قم بتغيير لغتك في أي وقت من محدد العلم - يتم التحديث فوراً',
                'help.tips.inputFixed': '✅ على الكمبيوتر، يبقى شريط الكتابة ثابتاً في أسفل الشاشة لمزيد من الراحة',
                'help.tips.invitations': '✅ ادع جهات اتصال عبر البريد الإلكتروني من ملفك الشخصي - حدد اللغة ووضع المحادثة من البداية',
                'help.tips.invitationsManagement': '✅ إدارة دعواتك من قائمة "الدعوات المرسلة" - إعادة إرسال رسائل البريد الإلكتروني أو إلغاء الدعوات المعلقة',
                'help.tips.contactStatus': '✅ راقب حالة كل جهة اتصال في القائمة - معلقة (برتقالي)، مسجلة (أخضر) أو محادثة نشطة (أزرق)',
                'help.tips.favorites': '✅ ضع علامة على جهات الاتصال كمفضلة بالنجمة ⭐ - تظهر المفضلة أولاً في قائمتك',
                'help.tips.profilePhoto': '✅ ارفع صورة ملفك الشخصي من "اختر من المعرض" - سترى معاينة قبل الحفظ',
                'help.tips.translationSender': '✅ عند إرسال رسالة، قم بتوسيع لوحة الترجمة لمعرفة كيفية ترجمتها إلى لغة المستلم',
                'help.tips.unifiedContacts': '✅ يتم عرض جهات اتصالك تلقائياً عندما يقبلون الدعوات أو عندما يكون لديك محادثات معهم',
                'help.tips.privacy': '✅ ملفك الشخصي خاص افتراضيًا - قم بتمكين الرؤية العامة في الملف الشخصي > الخصوصية إذا كنت تريد أن يجدك الآخرون',
                'help.tips.export': '✅ قم بتصدير المحادثات الكاملة باستخدام الزر ⬇️ في الرأس - اختر PDF أو HTML مع جميع الصور',
                'help.support.title': 'الدعم',
                'help.support.description': 'إذا كان لديك مشاكل أو أسئلة، اتصل بمسؤول النظام أو راجع الوثائق التقنية المتاحة.',
                'help.about.title': 'حول',
                'help.about.developer': 'تم التطوير بواسطة:',
                'help.about.location': 'MDQ - الأرجنتين',
                'help.about.linkedin': 'عرض ملف LinkedIn الشخصي',
                'presence.title': 'حالة الحضور',
                'presence.currentStatus': 'الحالة الحالية:',
                'presence.changeStatus': 'تغيير الحالة',
                'presence.status.online': 'متصل',
                'presence.status.online.title': 'متصل - مرئي للجميع',
                'presence.status.online.description': 'متصل: مرئي لجميع جهات الاتصال',
                'presence.status.idle': 'خامل',
                'presence.status.idle.title': 'خامل - يشير إلى غياب مؤقت',
                'presence.status.idle.description': 'خامل: يشير إلى أنك غير متاح مؤقتاً',
                'presence.status.dnd': 'عدم الإزعاج',
                'presence.status.dnd.title': 'عدم الإزعاج - يشير إلى أنك تفضل عدم المقاطعة',
                'presence.status.dnd.description': 'عدم الإزعاج: إشارة مرئية بأنك تفضل عدم المقاطعة',
                'presence.status.busy': 'مشغول',
                'presence.status.busy.title': 'مشغول - غير متاح',
                'presence.status.busy.description': 'مشغول: غير متاح',
                'presence.status.offline': 'غير متصل',
                'presence.status.offline.title': 'منقطع - الظهور كغير متصل',
                'presence.status.offline.description': 'غير متصل: الظهور كمنقطع',
                'presence.status.custom': 'مخصص',
                'presence.status.custom.title': 'مخصص - حالة فريدة مع رمز تعبيري',
                'presence.status.custom.description': 'مخصص: حالة فريدة مع رمز تعبيري ووقت انتهاء اختياري',
                'dashboard.title': 'لوحة التحكم',
                'dashboard.planUsage': 'استخدام الخطة',
                'dashboard.filesSummary': 'ملفاتي',
                'dashboard.promotions': 'عروض',
                'dashboard.sessions': 'الجلسات النشطة',
                'dashboard.explore': 'استكشف',
                'dashboard.noSessions': 'لا جلسات نشطة',
                'dashboard.welcomeTitle': 'مرحباً بك في ArChat®',
                'dashboard.welcomeSubtitle': 'تواصل بأي لغة.',
                'dashboard.stepInvite': 'الخطوة 1: دعوة أول جهة',
                'dashboard.stepMessage': 'الخطوة 2: إرسال أول رسالة',
                'dashboard.inviteContact': 'دعوة جهة',
                'dashboard.exploreArChat': 'استكشف ArChat',
                'dashboard.promotionsTitle': 'العروض',
                'dashboard.promotionsText': 'نظرة على برنامج الإحالة والمكافآت.',
                'dashboard.viewPromotions': 'عرض العروض',
                'dashboard.usageTitle': 'استخدام الباقة',
                'dashboard.sessionsTitle': 'الجلسات النشطة',
                'dashboard.sessionsEmpty': 'لا توجد جلسات نشطة',
                'dashboard.filesTitle': 'ملفاتي',
                'dashboard.viewFiles': 'عرض الملفات',
                'dashboard.noBlocks': 'لا توجد أقسام مفعّلة. فعّل واحداً على الأقل من الإعدادات.',
                'dashboard.openSettings': 'فتح الإعدادات',
                'dashboard.goToContacts': 'الانتقال إلى جهات الاتصال',
                'dashboard.recentInbound.title': 'آخر الرسائل الواردة',
                'dashboard.recentInbound.empty': 'لا توجد رسائل واردة حديثة.',
                'dashboard.recentInbound.error': 'تعذر تحميل الرسائل.',
                'dashboard.recentInbound.previewPhoto': 'صورة',
                'dashboard.recentInbound.previewFile': 'ملف',
                "dashboard.recentInbound.previewPdf": "قوات الدفاع الشعبي",
                'dashboard.recentInbound.previewUnavailable': 'الرسالة غير متاحة',
                'dashboard.recentInbound.readTitle': 'مقروء',
                'dashboard.recentInbound.unreadTitle': 'غير مقروء',
                'dashboard.recentConversations.title': 'محادثات حديثة',
                'dashboard.recentConversations.empty': 'لا توجد محادثات لعرضها.',
                'dashboard.recentConversations.error': 'تعذر تحميل المحادثات.',
                'dashboard.filesVisible': 'الملفات الظاهرة',
                'dashboard.filesSampleNote': 'يُحسب من الصفحة الأولى (حتى 500+).',
                'dashboard.loading': 'جاري تحميل البيانات...',
                'dashboard.error.title': 'خطأ',
                'dashboard.error.load': 'تعذر تحميل بيانات الاستخدام',
                'dashboard.error.generic': 'خطأ في تحميل لوحة التحكم',
                'dashboard.error.no_data': 'تعذر تحميل البيانات',
                'dashboard.retry': 'إعادة المحاولة',
                'dashboard.unlimited': 'غير محدود',
                "dashboard.plan.free": "FREE",
                "dashboard.plan.pro": "PRO",
                "dashboard.plan.enterprise": "ENTERPRISE",
                'dashboard.card.contacts': 'جهات الاتصال',
                'dashboard.card.chars': 'الأحرف',
                'dashboard.card.chars_month': 'الأحرف هذا الشهر',
                'dashboard.card.storage': 'التخزين',
                'dashboard.card.devices': 'الأجهزة النشطة',
                'dashboard.upgrade.title': 'هل تحتاج إلى المزيد من الموارد؟',
                'dashboard.upgrade.message': 'قم بترقية خطتك للحصول على المزيد من جهات الاتصال والأحرف والتخزين والأجهزة النشطة.',
                'dashboard.upgrade.button': 'ترقية الخطة',
                'upgrade.title': 'ترقية الخطة',
                'upgrade.close': 'إغلاق',
                'upgrade.cancel': 'إلغاء',
                'upgrade.activate': 'تفعيل خطة PRO',
                'upgrade.activating': 'جاري التفعيل...',
                'upgrade.price.note': '',
                'upgrade.comparison.title': 'مقارنة الخطط',
                'upgrade.free.label': 'الخطة المجانية',
                'upgrade.free.limits.contacts': 'حد أقصى 2 جهات اتصال',
                'upgrade.free.limits.conversations': 'حد أقصى 2 محادثات',
                'upgrade.free.limits.no_export': 'لا يوجد تصدير للبيانات',
                'upgrade.free.limits.no_advanced': 'لا توجد ميزات متقدمة',
                'upgrade.pro.label': 'خطة Pro',
                'upgrade.pro.recommended': 'موصى به',
                'upgrade.pro.benefits.contacts': 'جهات اتصال غير محدودة',
                'upgrade.pro.benefits.contacts.desc': 'أضف جميع جهات الاتصال التي تحتاجها دون قيود',
                'upgrade.pro.benefits.conversations': 'محادثات غير محدودة',
                'upgrade.pro.benefits.conversations.desc': 'احتفظ بجميع المحادثات النشطة التي تحتاجها',
                'upgrade.pro.benefits.export': 'تصدير المحادثات',
                'upgrade.pro.benefits.export.desc': 'قم بتصدير محادثاتك بتنسيقات متعددة (PDF، TXT، JSON)',
                'upgrade.pro.benefits.notifications': 'إشعارات متقدمة',
                'upgrade.pro.benefits.notifications.desc': 'إشعارات مخصصة وإعدادات متقدمة',
                'upgrade.pro.benefits.translation': 'ترجمة تلقائية غير محدودة',
                'upgrade.pro.benefits.translation.desc': 'ترجم الرسائل دون حدود استخدام',
                'upgrade.pro.benefits.files': 'إرسال ملفات غير محدود',
                'upgrade.pro.benefits.files.desc': 'شارك ملفات بأي حجم دون قيود',
                'upgrade.pro.benefits.themes': 'سمات مخصصة',
                'upgrade.pro.benefits.themes.desc': 'الوصول إلى جميع السمات والتخصيص المتقدم',
                'upgrade.pro.benefits.security': 'أمان متقدم',
                'upgrade.pro.benefits.security.desc': 'حماية إضافية وميزات خصوصية محسّنة',
                'upgrade.pro.benefits.analytics': 'إحصائيات وتحليلات',
                'upgrade.pro.benefits.analytics.desc': 'الوصول إلى إحصائيات مفصلة عن نشاطك',
                'upgrade.pro.benefits.priority': 'دعم ذو أولوية',
                'upgrade.pro.benefits.priority.desc': 'اهتمام ذو أولوية واستجابة سريعة لاستفساراتك',
                'upgrade.enterprise.label': 'خطة Enterprise',
                'upgrade.enterprise.benefits.contacts': 'جهات اتصال غير محدودة',
                'upgrade.enterprise.benefits.support': 'دعم ذو أولوية 24/7',
                'upgrade.enterprise.benefits.custom': 'حلول مخصصة',
                'upgrade.enterprise.benefits.advanced': 'ميزات مؤسسية متقدمة',
                'upgrade.enterprise.benefits.integration': 'تكاملات مخصصة',
                'upgrade.enterprise.benefits.dedicated': 'دعم مخصص',
                'upgrade.success.title': 'تم تفعيل خطة PRO',
                'upgrade.success.message': 'تم تحديث خطتك إلى PRO. استمتع بجميع الميزات غير المحدودة.',
                'upgrade.error.title': 'خطأ في تفعيل PRO',
                'upgrade.error.message': 'تعذر تحديث الخطة. يرجى المحاولة مرة أخرى.',
                'upgrade.error.generic': 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.',
                'upgrade.benefits.contacts': 'جهات اتصال غير محدودة',
                'upgrade.benefits.contacts.desc': 'أضف جميع جهات الاتصال التي تحتاجها دون قيود',
                'upgrade.benefits.conversations': 'محادثات غير محدودة',
                'upgrade.benefits.conversations.desc': 'احتفظ بجميع المحادثات النشطة التي تحتاجها',
                'upgrade.benefits.export': 'تصدير المحادثات',
                'upgrade.benefits.export.desc': 'قم بتصدير محادثاتك بتنسيقات متعددة (PDF، TXT، JSON)',
                'upgrade.benefits.notifications': 'إشعارات متقدمة',
                'upgrade.benefits.notifications.desc': 'إشعارات مخصصة وإعدادات متقدمة',
                'upgrade.benefits.translation': 'ترجمة تلقائية غير محدودة',
                'upgrade.benefits.translation.desc': 'ترجم الرسائل دون حدود استخدام',
                'upgrade.benefits.files': 'إرسال ملفات غير محدود',
                'upgrade.benefits.files.desc': 'شارك ملفات بأي حجم دون قيود',
                'upgrade.benefits.themes': 'سمات مخصصة',
                'upgrade.benefits.themes.desc': 'الوصول إلى جميع السمات والتخصيص المتقدم',
                'upgrade.benefits.security': 'أمان متقدم',
                'upgrade.benefits.security.desc': 'حماية إضافية وميزات خصوصية محسّنة',
                'upgrade.benefits.analytics': 'إحصائيات وتحليلات',
                'upgrade.benefits.analytics.desc': 'الوصول إلى إحصائيات مفصلة عن نشاطك',
                'upgrade.benefits.priority': 'دعم ذو أولوية',
                'upgrade.benefits.priority.desc': 'اهتمام ذو أولوية واستجابة سريعة لاستفساراتك',
                'upgrade.limits.contacts': 'حد أقصى 2 جهات اتصال',
                'upgrade.limits.conversations': 'حد أقصى 2 محادثات',
                'upgrade.limits.no_export': 'لا يوجد تصدير للبيانات',
                'upgrade.limits.no_advanced': 'لا توجد ميزات متقدمة',
                // API Error Messages
                'api.error.image_processing_not_available': 'معالجة الصور غير متاحة على الخادم',
                'api.error.image_functions_not_available': 'وظائف معالجة الصور غير متاحة',
                'api.error.method_not_allowed': 'طريقة غير مسموحة',
                'api.error.user_not_identified': 'المستخدم غير محدد',
                'api.error.upload_file_too_large_php': 'الملف يتجاوز الحد الأقصى للحجم المسموح به بواسطة PHP',
                'api.error.upload_file_too_large_form': 'الملف يتجاوز الحد الأقصى للحجم المسموح به بواسطة النموذج',
                'api.error.upload_file_partial': 'تم رفع الملف جزئياً',
                'api.error.upload_no_file': 'لم يتم رفع أي ملف',
                'api.error.upload_no_temp_dir': 'مجلد مؤقت مفقود',
                'api.error.upload_cant_write': 'خطأ في كتابة الملف على القرص',
                'api.error.upload_extension_stopped': 'أوقفت إضافة PHP الرفع',
                'api.error.upload_generic': 'خطأ في رفع الملف',
                'api.error.file_type_not_allowed': 'نوع الملف غير مسموح. الصور فقط مسموحة (JPEG, PNG, GIF, WEBP)',
                'api.error.file_too_large': 'الملف كبير جداً (حد أقصى 10MB)',
                'api.error.storage_limit_exceeded': 'تم تجاوز حد التخزين. قم بترقية خطتك لرفع المزيد من الملفات.',
                'api.error.user_not_found': 'المستخدم غير موجود أو غير نشط',
                'api.error.image_directory_access': 'خطأ في الوصول إلى مجلد الصور',
                'api.error.file_extension_not_allowed': 'امتداد الملف غير مسموح',
                'api.error.temp_file_save': 'خطأ في حفظ الملف المؤقت',
                'api.error.image_processing': 'خطأ في معالجة الصورة',
                'api.error.database_update': 'خطأ في تحديث قاعدة البيانات',
                'api.error.internal_server_error': 'خطأ داخلي في الخادم',
                'api.error.internal_server_error_debug': 'خطأ داخلي في الخادم',
                'api.error.user_id_required': 'معرف المستخدم مطلوب',
                'api.error.profile_not_found': 'الملف الشخصي غير موجود',
                'api.error.profile_load_failed': 'خطأ في تحميل الملف الشخصي',
                'api.error.invalid_data': 'بيانات غير صالحة',
                'api.error.validation_errors': 'أخطاء التحقق',
                'api.error.profile_update_failed': 'تعذر تحديث الملف الشخصي',
                'api.error.profile_update_error': 'خطأ في تحديث الملف الشخصي',
                // API Success Messages
                'api.success.photo_updated': 'تم تحديث الصورة',
                'api.success.profile_loaded': 'تم تحميل الملف الشخصي بنجاح',
                'api.success.profile_updated': 'تم تحديث الملف الشخصي بنجاح',
                // Error Messages - Device Limits
                'errors.deviceLimit.title': 'تم الوصول إلى حد الأجهزة',
                'errors.deviceLimit.solution': 'لمتابعة، قم بتسجيل الخروج من الأجهزة الأخرى أو قم بترقية خطتك.',
                // Error Messages - Network
                'errors.network.title': 'خطأ في الاتصال',
                'errors.network.message': 'تعذر الاتصال بالخادم. تحقق من اتصالك بالإنترنت.',
                // Error Messages - Server
                'errors.server.invalidResponse.title': 'خطأ في الخادم',
                'errors.server.invalidResponse.message': 'أعاد الخادم استجابة غير صالحة. يرجى المحاولة مرة أخرى.',
                // Error Messages - Generic
                'errors.generic.title': 'خطأ',
                'errors.generic.message': 'حدث خطأ. يرجى المحاولة مرة أخرى.',
                'errors.generic.403.title': 'خطأ في الوصول',
                'errors.generic.403.message': 'ليس لديك إذن لتنفيذ هذا الإجراء.',
                'errors.saas_max_users': 'تم الوصول إلى حد مستخدمي الخطة ({current}/{limit}).',
                'errors.tenant_frozen': 'المستأجر مغلق مؤقتاً.',
                'errors.auth_invalid_credentials': 'اسم المستخدم أو كلمة المرور غير صحيحة.',
                'errors.accountInactive.title': 'الحساب غير نشط. أدخل بريدك الإلكتروني لإعادة التفعيل.',
                'errors.accountInactive.activate': 'تفعيل الآن',
                'errors.accountInactive.accept': 'قبول',
                'errors.accountInactive.success': 'تم إعادة تفعيل الحساب. يمكنك تسجيل الدخول الآن.',
                'errors.accountInactive.fail': 'تعذر إعادة تفعيل الحساب. يرجى المحاولة مرة أخرى.',
                'errors.accountInactive.completeSuccess': 'تم تفعيل الحساب بريدك الإلكتروني. يمكنك تسجيل الدخول الآن.',
                'errors.accountInactive.completeFail': 'تعذر إكمال التفعيل. تحقق من البريد الإلكتروني وحاول مرة أخرى.',
                // Plan Errors - Device Limit
                'plan.errors.deviceLimit.title': 'تم الوصول إلى حد الخطة',
                'plan.errors.deviceLimit.message': 'خطتك الحالية لها حد على عدد الأجهزة التي يمكن توصيلها في نفس الوقت.',
                'plan.errors.deviceLimit.solution': 'لمتابعة، قم بتسجيل الخروج من الأجهزة الأخرى أو قم بترقية خطتك إلى PRO.',
                // Plan Errors - Contacts Limit
                'plan.errors.contactsLimit.title': 'تم الوصول إلى حد جهات الاتصال',
                'plan.errors.contactsLimit.message': 'خطتك الحالية لها حد على عدد جهات الاتصال التي يمكنك الحصول عليها.',
                'plan.errors.contactsLimit.solution': 'لإضافة المزيد من جهات الاتصال، قم بترقية خطتك إلى PRO.',
                // Plan Errors - Invitations Limit
                'plan.errors.invitationsLimit.title': 'تم الوصول إلى حد الدعوات',
                'plan.errors.invitationsLimit.message': 'خطتك الحالية لها حد على عدد الدعوات التي يمكنك إرسالها يوميًا.',
                'plan.errors.invitationsLimit.solution': 'لإرسال المزيد من الدعوات، قم بترقية خطتك إلى PRO.',
                // Plan Errors - Messages Limit
                'plan.errors.messagesLimit.title': 'تم الوصول إلى حد الرسائل',
                'plan.errors.messagesLimit.message': 'خطتك الحالية لها حد على عدد الرسائل التي يمكنك إرسالها يوميًا.',
                'plan.errors.messagesLimit.solution': 'لإرسال المزيد من الرسائل، قم بترقية خطتك إلى PRO.',
                // Plan Errors - Storage Limit
                'plan.errors.storageLimit.title': 'تم الوصول إلى حد التخزين',
                'plan.errors.storageLimit.message': 'خطتك الحالية لها حد على كمية التخزين المتاحة.',
                'plan.errors.storageLimit.solution': 'للحصول على المزيد من التخزين، قم بترقية خطتك إلى PRO.',
                // Plan Errors - Upgrade Required
                'plan.errors.upgradeRequired.title': 'مطلوب ترقية الخطة',
                'plan.errors.upgradeRequired.message': 'تتطلب هذه الميزة خطة أعلى من خطتك الحالية.',
                'plan.errors.upgradeRequired.solution': 'قم بترقية خطتك إلى PRO للوصول إلى هذه الميزة.',
                "appearance.theme.system": "نظام",
                "appearance.theme.corporate": "شركة كبرى",
                "theme.system": "نظام",
                "theme.corporate": "شركة كبرى",
                'founder.title': 'FOUNDATION (المؤسس)',
                'founder.subtitle': 'تدعم المشروع من البداية بسعر مدى الحياة.',
                'founder.whatIs': 'أول 150 مستخدماً يحصلون على خطة FOUNDATION بسعر مخفض مدى الحياة.',
                'founder.howItWorks': 'مستوى المؤسس يعتمد على موقعك (1 إلى 150).',
                'founder.benefitsTitle': 'المزايا',
                'founder.benefitPrice': '$15 / شهر (سعر Founder)',
                'founder.benefitFeatures': 'يتضمن جميع ميزات خطة PRO.',
                'founder.limit': 'يوجد 150 مكاناً للمؤسسين فقط.',
                'founder.cancelRule': 'إذا ألغيت، تفقد صفة المؤسس أثناء إلغاء الاشتراك.',
                'founder.rejoinRule': 'إذا توفر مكان مجدداً، يمكنك إعادة التفعيل والانضمام كمؤسس تلقائياً.',
                'founder.tiers.title': 'مستويات المؤسس',
                'founder.tiers.legendary.name': 'مؤسس أسطوري',
                'founder.tiers.legendary.range': 'الموقع 1–25',
                'founder.tiers.legendary.desc': 'الأوائل في دعم المشروع. أعلى أولوية تاريخية.',
                'founder.tiers.early.name': 'مؤسس مبكر',
                'founder.tiers.early.range': 'الموقع 26–75',
                'founder.tiers.early.desc': 'دعم مبكر مع اعتراف خاص.',
                'founder.tiers.founder.name': 'مؤسس',
                'founder.tiers.founder.range': 'الموقع 76–150',
                'founder.tiers.founder.desc': 'مكان مؤسس ضمن 150.',
                'founder.whatIsLink': 'ما هو المؤسس؟',
                'founder.viewTiers': 'عرض مستويات المؤسس',
                'founder.modalClose': 'إغلاق',
                'founder.activeCountLabel': 'المؤسسون النشطون',
                'founder.urgency.lastSlots': 'آخر الأماكن المتاحة للمؤسسين',
                "founder.positionLabel": "المؤسس #{position} / {limit}",
                'founder.leaderboard.title': 'أفضل المؤسسين',
                "login.email.placeholder": "Ingresa tu email para confirmar tu cuenta",
                "login.email.help": "سيتم إرسال رابط التأكيد إلى بريدك الإلكتروني",
                "auth.user_not_found": "لم يتم العثور على المستخدم.",
                "auth.user_inactive": "تم تعطيل حسابك. اتصل بالمسؤول.",
                "auth.tenant_mismatch": "حسابك لا ينتمي إلى هذه البيئة. اتصل بالمسؤول.",
                "auth.captcha_required": "يجب عليك إكمال التحقق الأمني ​​(CAPTCHA).",
                "mail.send_failed": "تعذر إرسال البريد الإلكتروني المخصص للطوارئ. تحقق من إعدادات SMTP أو حاول مرة أخرى لاحقًا.",
                "auth.resend_activation": "إعادة إرسال البريد الإلكتروني للتنشيط",
                "register.creatingAccount": "جارٍ إنشاء حسابك…",
                "common.edit": "يحرر",
                "common.on": "تفعيلها",
                "common.off": "عاجز",
                "common.refresh": "تحديث",
                "system.processing": "يعالج...",
                "captcha.incorrect": "إجابة كلمة التحقق غير صحيحة.",
                "captcha.placeholder": "اكتب الجواب",
                "captcha.questionFormat": "ما هو {أ} + {ب}؟",
                'menu.admin': 'الإدارة',
                "navbar.users": "المستخدمين",
                'navbar.no_blocked_users': 'لا يوجد مستخدمون محظورون',
                'navbar.blocked_users_title': 'المستخدمون المحظورون',
                'contacts.blocked_users_title': 'المستخدمون المحظورون',
                'contacts.country_label': 'البلد',
                'contacts.not_reported': 'غير مُبلغ عنه',
                "navbar.user_fallback": "المستخدم {المعرف}",
                "navbar.open_guide": "مرشد",
                "help.how_archat_works": "كيف يعمل آرتشات®",
                "help.registration": "سِجِلّ",
                "help.private_invitations": "دعوات خاصة",
                "help.messaging": "المراسلة",
                "help.security": "حماية",
                "invitation.quick_button": "دعوة جهة اتصال",
                "onboarding.title": "مرحبًا بك في ArChat®",
                "onboarding.subtitle": "التواصل مع أي شخص بأي لغة.",
                "onboarding.step1.label": "الخطوة 1",
                "onboarding.step1.text": "قم بدعوة جهة الاتصال الأولى الخاصة بك",
                "onboarding.step2.label": "الخطوة 2",
                "onboarding.step2.text": "أرسل رسالتك الأولى",
                "onboarding.actions.invite": "دعوة جهة اتصال",
                "onboarding.actions.explore": "اكتشف ArChat®",
                'suggestions.sendSuccess': 'تم إرسال اقتراحك بنجاح.',
                'suggestions.sendError': 'تعذر إرسال الاقتراح. يرجى المحاولة مرة أخرى.',
                'suggestions.sent': 'تم إرسال الاقتراح بنجاح.',
                'errors.suggestionSend': 'تعذر إرسال الاقتراح. يرجى المحاولة مرة أخرى.',
                "common.requiredFields": "أكمل كافة الحقول المطلوبة.",
                "bio.view": "انظر السيرة الذاتية",
                "profile.nick.readonly": "لا يمكن تعديل اسم المستخدم",
                "profile.nick.readonly.help": "اسم المستخدم فريد ولا يمكن تعديله",
                "profile.email.readonly": "لا يمكن تعديل البريد الإلكتروني",
                "profile.email.readonly.help": "البريد الإلكتروني فريد ولا يمكن تعديله",
                "profile.invitations.title": "الدعوات",
                "profile.invitations.validated": "الدعوات المعتمدة",
                "profile.invitations.nextBadge": "الإنجاز القادم",
                "profile.invitations.progress": "تقدم",
                "profile.invitations.achievement": "إنجاز",
                "profile.invitations.topInviterAchieved": "تم الوصول إلى الحد الأقصى لعدد المدعوين",
                "profile.invitations.badges.networkBuilder": "منشئ الشبكة",
                "profile.invitations.badges.topInviter": "الحد الأقصى للداعي",
                "profile.invitations.achievement.networkBuilderMessage": "لقد قمت بدعوة 20 مستخدمًا إلى ArChat.",
                "profile.invitations.achievement.topInviterMessage": "لقد قمت بدعوة 50 مستخدمًا على ArChat.",
                "profile.plan.loading_info": "جارٍ تحميل معلومات الخطة...",
                "profile.plan.valid_until": "صالحة حتى:",
                "profile.plan.active_since": "نشط منذ:",
                "profile.plan.active_badge": "✓ نشط",
                "profile.manage_plan": "إدارة الخطة",
                "plan.current_plan": "الخطة الحالية",
                "plan.current": "Actual",
                'plan.footer_prefix': 'الخطة:',
                "plan.upgrade_to_pro": "الترقية إلى PRO",
                "plan.upgrade_to_foundation": "الترقية إلى المؤسسة",
                "plan.payment_coming": "سيكون الدفع باستخدام Paddle متاحًا قريبًا. يمكنك تغيير الخطط من هنا.",
                "plan.payment_coming_title": "قريباً",
                "plan.foundation_full": "حصة المؤسسة ممتلئة (150 مؤسسًا). يمكنك اختيار PRO.",
                "plan.sold_out": "مرهق",
                "plan.founder_spots_remaining": "يتوفر فقط {count} من الأماكن",
                "plan.founders_occupied": "مؤسسين مشغولين",
                "plan.upgrade_not_allowed": "يمكن فقط للمستخدمين الذين لديهم خطة مجانية طلب الترقية.",
                "plan.free_contacts": "Hasta 2 contactos",
                "plan.free_no_files": "Sin archivos",
                "plan.free_retention": "Historial 30 días",
                "plan.pro_files": "Archivos hasta 50MB",
                "plan.pro_export": "Exportación",
                "plan.founder_support": "Prioridad soporte",
                "plan.founder_badge": "Badge fundador",
                "billing.usage.contacts": "اتصالات",
                "billing.usage.chars_month": "الشخصيات شهريا",
                "billing.usage.storage": "تخزين مستعمل",
                "billing.usage.devices": "الأجهزة المتصلة",
                "billing.loading": "جاري الشحن...",
                'billing.subscription.section_title': 'الاشتراك والفوترة',
                'billing.subscription.provider_note': 'المزوّد',
                'billing.subscription.paddle_active': 'Paddle (خطة نشطة في التطبيق)',
                'billing.subscription.mp_action_ok': 'تم تسجيل الطلب. إذا لم يُفتح الدفع، تحقق من الاتصال أو أعد المحاولة.',
                'billing.paddle.manage_subscription_button': 'إدارة الاشتراك',
                'billing.paddle.portal_confirm_title': 'بوابة الفوترة',
                'billing.paddle.portal_confirm': 'سيفتح بوابة Paddle الآمنة لتحديث طريقة الدفع أو الفواتير أو إلغاء الاشتراك. هل تريد المتابعة؟',
                'billing.paddle.portal_opened_hint': 'تم فتح بوابة Paddle في تبويب جديد. حدّث ملفك الشخصي إذا لم يتحدث الخطة.',
                'billing.paddle.portal_error': 'تعذر فتح بوابة Paddle. حاول لاحقاً أو اتصل بالدعم.',
                'billing.paddle.no_link_error': 'لا يوجد ربط اشتراك Paddle لحسابك بعد. إذا دفعت للتو، انتظر webhook أو اتصل بالدعم.',
                'billing.paddle.api_not_configured': 'الخادم يفتقد إعدادات Paddle API (PADDLE_API_KEY). يجب على المسؤول ضبطها.',
                "billing.descriptions.contacts": "إجمالي جهات الاتصال المخزنة في حسابك",
                "billing.descriptions.storage": "التخزين المستخدم للملفات والوسائط",
                "billing.descriptions.chars_month": "الشخصيات المترجمة هذا الشهر",
                "billing.descriptions.devices": "الأجهزة المتصلة النشطة",
                'billing.paddle.return_title': 'تم استلام الدفع',
                'billing.paddle.return_body': 'إذا أكملت الدفع، ستُحدَّث خطتك قريباً بعد تأكيد Paddle. يمكنك العودة إلى الصفحة الرئيسية.',
                'billing.paddle.verifying': 'جارٍ التحقق من خطتك…',
                'billing.paddle.not_logged_in': 'سجّل الدخول لرؤية حالة خطتك المحدثة.',
                'billing.paddle.plan_updated': 'تم تحديث الخطة بنجاح: {plan}',
                'billing.paddle.plan_current': 'خطتك الحالية: {plan}',
                'billing.paddle.plan_current_founder': 'أصبحت الآن Founder — {plan}',
                'billing.paddle.still_free_hint': 'إذا ظلّ FREE بعد ثوانٍ، قد يتأخر webhook. راجع سجلات الخادم أو حدّث هذه الصفحة.',
                'billing.paddle.pro_extra_hint': 'يمكنك العودة إلى الصفحة الرئيسية لاستخدام خطتك.',
                "attachment.audioNotSupported": "الرسائل الصوتية غير مدعومة في ArChat®. الرجاء ارسال رسالة مكتوبة.",
                "message.audioDeprecated.title": "الرسالة الصوتية غير مدعومة",
                "message.audioDeprecated.message": "لم تعد هذه الرسالة الصوتية مدعومة بواسطة ArChat®. الرجاء ارسال رسالة مكتوبة.",
                "profile.photo.select": "حدد الصورة",
                "profile.photo.select.gallery": "اختر من المعرض",
                "avatar.errors.too_large": "الصورة كبيرة جدًا. الحد الأقصى للحجم: 2 ميجابايت.",
                "avatar.preview.title": "معاينة الصورة الرمزية",
                "profile.avatar.error_title": "لا يمكن تحديث الصورة الرمزية",
                "profile.avatar.error.title": "لا يمكن تحديث الصورة الرمزية",
                "profile.avatar.error.size": "الصورة تتجاوز الحجم المسموح به. الحد الأقصى هو 2 ميغابايت.",
                "profile.avatar.tooLarge.title": "الصورة كبيرة جدًا",
                "profile.avatar.tooLarge.message": "الصورة تتجاوز الحجم المسموح به. الحد الأقصى هو 2 ميغابايت.",
                "profile.avatar.uploadError.title": "لا يمكن تحديث الصورة الرمزية",
                "profile.avatar.uploadError.message": "حدثت مشكلة في تحميل الصورة. حاول ثانية.",
                "profile.saveSuccess.title": "تحديث الملف الشخصي",
                "profile.saveSuccess.message": "تم حفظ تغييراتك بنجاح.",
                "profile.avatar.file_too_large": "تتجاوز الصورة الحد الأقصى للحجم المسموح به (2 ميغابايت).",
                "profile.avatar.file_too_large_hint": "اختر صورة أفتح أو قلل حجمها ثم حاول مرة أخرى.",
                "profile.photo.take.front": "الكاميرا الأمامية",
                "profile.photo.take.back": "الكاميرا الخلفية",
                "profile.photo.take.webcam": "كاميرا ويب",
                "profile.photo.camera.front": "الكاميرا الأمامية",
                "profile.photo.camera.back": "الكاميرا الخلفية",
                "profile.photo.camera.web": "كاميرا ويب",
                "profile.photo.close": "يغلق",
                "profile.photo.capture": "يأسر",
                "block.toggle_error": "لا يمكن قفل أو فتح.",
                "contact.favorite.add": "أضف إلى المفضلة",
                "contact.favorite.remove": "إزالة من المفضلة",
                "contact.block.block": "حاجز",
                'contact.block.unblock': 'إلغاء الحظر',
                "conversation.notFound": "لم يتم العثور على المحادثة",
                "help.howWorks.title": "👥 كيف يعمل ArChat® (التدفق الحقيقي)",
                "help.howWorks.step1.title": "1️⃣ التسجيل",
                "help.howWorks.step1.point1": "تسجيل الدخول باستخدام اللقب وكلمة المرور الخاصة بك.",
                "help.howWorks.step1.point2": "إذا لم يكن لديك حساب، فسيتم إنشاؤه تلقائيًا.",
                "help.howWorks.step1.point3": "أنت توافق على الشروط والأحكام بلغتك.",
                "help.howWorks.step1.point4": "قمت بتأكيد حسابك عن طريق البريد الإلكتروني.",
                "help.howWorks.step2.title": "2️⃣دعوات خاصة",
                "help.howWorks.step2.point1": "قم بدعوة جهات الاتصال عبر البريد الإلكتروني من ملفك الشخصي.",
                "help.howWorks.step2.point2": "تحديد اللغة ووضع المحادثة قبل البدء.",
                "help.howWorks.step2.point3": "تتلقى جهة الاتصال دعوة خاصة.",
                "help.howWorks.step2.point4": "يمكنك معرفة ما إذا كان: معلق، مسجل، جاهز للدردشة",
                "help.howWorks.step2.point5": "لا يتم البحث عن جهات الاتصال، بل يتم دعوتهم.",
                "help.howWorks.step2.point6": "لا يتم البحث عن جهات الاتصال، بل يتم دعوتهم.",
                "help.howWorks.step3.title": "3️⃣ جهات الاتصال والمحادثات",
                "help.howWorks.step3.point1": "تظهر جهات الاتصال الخاصة بك تلقائيًا عندما:",
                "help.howWorks.step3.point2": "قبول دعوة",
                "help.howWorks.step3.point3": "أو هناك محادثة",
                "help.howWorks.step3.point4": "يستطيع:",
                "help.howWorks.step3.point5": "ضع علامة عليها في المفضلة ⭐",
                "help.howWorks.step3.point6": "تعيين أسماء مستعارة مخصصة لهم",
                "help.howWorks.step3.point7": "إضافة ملاحظات خاصة",
                "help.howWorks.step3.point8": "حظرها أو إدارتها",
                "help.howWorks.step3.point9": "لا توجد أجندة عامة أو مستخدمين مرئيين دون موافقة.",
                "help.howWorks.step4.title": "4️⃣ الرسائل مع الترجمة",
                "help.howWorks.step4.point1": "اكتب دائمًا بلغتك.",
                "help.howWorks.step4.point2": "يقوم النظام تلقائيًا بترجمة الرسالة.",
                "help.howWorks.step4.point3": "ويستقبلها المتلقي بلغته.",
                "help.howWorks.step4.point4": "تستطيع أن ترى الترجمة المطبقة.",
                "help.howWorks.step4.point5": "إذا فشلت الترجمة، تتم إعادة المحاولة تلقائيًا.",
                "help.howWorks.step4.point6": "يعطي ArChat® الأولوية للوضوح والمعنى، وليس فقط للسرعة.",
                "help.privacy.title": "🔒 الخصوصية والتحكم",
                "help.privacy.point1": "ملفك الشخصي خاص بشكل افتراضي.",
                "help.privacy.point2": "يمكن فقط لأولئك الذين تدعوهم رؤيتك أو الكتابة إليك.",
                "help.privacy.point3": "الرؤية العامة اختيارية ويتم تعطيلها افتراضيًا.",
                "help.privacy.point4": "السلامة النشطة مع:",
                "help.privacy.point5": "اختبار CAPTCHA",
                "help.privacy.point6": "الحد من المعدل",
                "help.privacy.point7": "بصمة",
                "help.privacy.point8": "التحقق من البريد الإلكتروني",
                "help.privacy.point9": "محادثاتك ليست عامة أو مفهرسة.",
                "help.files.title": "📎 الملفات والتصدير",
                "help.files.point1": "إرفاق الصور ومقاطع الفيديو ومستندات PDF.",
                "help.files.point2": "التقط الصور باستخدام الكاميرا الأمامية أو الكاميرا الخلفية أو كاميرا الويب.",
                "help.files.point3": "يتم ضغط الصور تلقائيًا.",
                "help.files.point4": "معاينة قبل الإرسال.",
                "help.files.point5": "شريط التقدم أثناء التحميل.",
                "help.files.point6": "تصدير المحادثات بأكملها إلى:",
                "help.files.point7": "قوات الدفاع الشعبي",
                "help.files.point8": "أتش تي أم أل",
                "help.files.point9": "يتضمن الرسائل والصور والملفات.",
                "help.files.point10": "بياناتك ملكك.",
                "help.experience.title": "🎨 تجربة المستخدم",
                "help.experience.point1": "حالات الحضور والحالات المخصصة باستخدام الرموز التعبيرية.",
                "help.experience.point2": "رموز تعبيرية مدمجة لـ OpenMoji.",
                "help.experience.point3": "قراءة وكتابة المؤشرات.",
                "help.experience.point4": "عرض الهاتف المحمول الأمثل يساوي سطح المكتب.",
                "help.experience.point5": "تطبيق PWA قابل للتثبيت.",
                "help.experience.point6": "موضوعان: الأرجنتين (أزرق فاتح/أبيض/ذهبي) وأوسكورو (أرجواني غامق).",
                "help.experience.point7": "تحرير الملف الشخصي بدون مشروبات غازية.",
                "help.experience.point8": "محدد البلد مع المنطقة الزمنية التلقائية.",
                "help.experience.point9": "الوصول السريع إلى المفضلة والبحث والمرشحات.",
                "help.languages.title": "🌍 اللغات",
                "help.languages.point1": "دعم للغات {count}.",
                "help.languages.point2": "محدد مرئي مع الأعلام.",
                "help.languages.point3": "الواجهة والشروط والأحكام ورسائل البريد الإلكتروني تتكيف مع اللغة المختارة.",
                "help.languages.point4": "الترجمة الآلية في اتجاهين بين المستخدمين.",
                "help.tipsNew.title": "💡 نصائح للاستفادة من ArChat®",
                "help.tipsNew.point1": "قم بدعوة الأشخاص الذين تريد التواصل معهم فقط.",
                "help.tipsNew.point2": "استخدم الأسماء المستعارة والملاحظات الخاصة لتنظيم جهات الاتصال.",
                "help.tipsNew.point3": "ضع علامة على المفضلة للوصول السريع.",
                "help.tipsNew.point4": "تحقق من الترجمة قبل إرسال الرسائل المهمة.",
                "help.tipsNew.point5": "تصدير المحادثات ذات الصلة للنسخ الاحتياطي أو العمل.",
                "help.tipsNew.point6": "استخدم ArChat® عندما يكون الوضوح الكتابي أمرًا أساسيًا.",
                "help.whySubscribe.title": "🚀 لماذا تشترك في ArChat®",
                "help.whySubscribe.point1": "لم يتم تصميم ArChat® للدردشة مع أي شخص،",
                "help.whySubscribe.point2": "ولكن للتواصل بشكل أفضل مع من يهمهم الأمر.",
                "help.whySubscribe.point3": "إذا كنت بحاجة إلى:",
                "help.whySubscribe.point4": "الوضوح بين اللغات",
                "help.whySubscribe.point5": "الخصوصية الحقيقية",
                "help.whySubscribe.point6": "التحكم في الاتصال",
                "help.whySubscribe.point7": "تصدير المحادثة",
                "help.whySubscribe.point8": "تجربة احترافية وخالية من الضوضاء",
                "help.whySubscribe.point9": "تم تصميم ArChat® لذلك.",
                "help.message_time_context.title": "السياق الزمني للرسائل",
                "help.message_time_context.description": "يمكن لكل رسالة حفظ التوقيت المحلي والمنطقة الزمنية والبلد للمرسل في وقت الإرسال. بهذه الطريقة يمكنك معرفة أين وفي أي وقت أرسل المستخدم الآخر.",
                "help.message_time_context.point1": "في الخطة المجانية، يتم عرض الوقت في منطقتك الزمنية (جهاز الاستقبال) فقط.",
                "help.message_time_context.point2": "في خطة PRO، يتم أيضًا عرض التوقيت المحلي والبلد والمنطقة الزمنية الخاصة بجهة الإصدار.",
                "help.message_time_context.point3": "يتم حفظ السياق تاريخياً في كل رسالة.",
                "help.message_time_context.point4": "تتوفر ميزات التدقيق المتقدمة في الخطط الأعلى.",
                "help.tips.writing": "✅ كتابة رسائل واضحة: يقوم تطبيق ArChat® بترجمة معنى النص المكتوب، مع الحفاظ على السياق والوضوح",
                'presence.custom.title': 'حالة مخصصة',
                'presence.custom.status': 'الحالة المخصصة',
                'presence.custom.placeholder': 'مثال: أشرب قهوة ☕',
                'presence.custom.emoji': 'إيموجي (اختياري)',
                'presence.custom.emojiHelp': 'اختر إيموجي أو اكتب واحدا',
                'presence.custom.temporary': 'حالة مؤقتة (تنتهي تلقائيا)',
                'presence.custom.expiration': 'تاريخ الانتهاء',
                'presence.custom.expirationHelp': 'ستعود الحالة إلى "متصل" عند انتهاء الوقت',
                'presence.custom.suggestions': 'اقتراحات',
                'presence.custom.preview': 'معاينة',
                'presence.custom.save': 'حفظ الحالة',
                'presence.custom.required': 'الحالة المخصصة مطلوبة',
                'presence.custom.maxLength': 'الحد الأقصى 64 حرفا',
                'presence.custom.expirationRequired': 'يجب اختيار تاريخ انتهاء',
                'presence.custom.expirationFuture': 'يجب أن يكون تاريخ الانتهاء في المستقبل',
                'presence.custom.selectEmoji': 'اختيار إيموجي',
                "invitation.success.title": "تم إرسال الدعوة",
                "invitation.success.message": "تم إرسال الدعوة بنجاح.\\n\\nستتلقى جهة الاتصال رسالة بريد إلكتروني تحتوي على رابط لقبول الدعوة. بمجرد قبوله، يمكنك البدء في الدردشة معه.",
                "invitation.top.title": "كبار بناة الشبكة",
                "invitation.top.invitesSuffix": "الدعوات",
                "invitation.ranking.position": "موضع",
                "invitation.ranking.user": "مستخدم",
                "invitation.ranking.validatedInvites": "الدعوات المعتمدة",
                "invitation.ranking.empty": "لا توجد دعوات تم التحقق من صحتها لعرضها.",
                "invitation.ranking.loading": "جارٍ تحميل التصنيف...",
                "invitation.ranking.loadError": "لا يمكن تحميل الترتيب.",
                "invitations.waitBeforeResend": "لا يمكنك إعادة إرسال الدعوة بعد. يجب عليك الانتظار لمدة 10 دقائق بين كل عملية إرسال لتجنب إرسال بريد عشوائي للمستخدم الضيف.",
                "invitations.captchaQuestion": "كم هو %1 + %2؟",
                "invitations.resendSuccess": "تم تحويل الدعوة بنجاح.",
                "invitations.dailyLimit": "لقد وصلت إلى الحد الأقصى المسموح به لعمليات إعادة الإرسال اليوم.",
                "invitations.invalidEmail": "أبلغ خادم البريد أن هذا العنوان غير صالح.",
                "achievement.unlocked": "تم فتح الإنجاز",
                "achievement.continue": "يكمل",
                'dashboard.not_available': 'غير متاح',
                "plan.errors.chatsLimit.title": "تم الوصول إلى حد المحادثة",
                "plan.errors.chatsLimit.message": "تحتوي خطتك الحالية على حد لعدد المحادثات التي يمكنك إجراؤها.",
                "plan.errors.chatsLimit.solution": "لإنشاء المزيد من المحادثات، قم بترقية خطتك إلى PRO.",
                "errors.generic": "حدث خطأ غير متوقع. حاول ثانية.",
                "errors.modal.title": "خطأ",
                "errors.modal.copyDetails": "نسخ التفاصيل",
                "errors.modal.close": "يغلق",
                "errors.modal.reportSupport": "تقرير إلى الدعم",
                "errors.avatarTooLarge": "تتجاوز الصورة الحجم المسموح به وهو 2 ميغابايت.",
                "errors.avatarTooLarge.title": "الصورة كبيرة جدًا",
                "errors.avatarTooLarge.message": "تتجاوز الصورة الحجم المسموح به وهو 2 ميغابايت.",
                "errors.invalidImageType": "الملف المحدد ليس صورة صالحة.",
                "errors.invalidImageType.title": "ملف غير صالح",
                "errors.invalidImageType.message": "الملف المحدد ليس صورة صالحة.",
                "errors.uploadFailed": "لا يمكن تحميل الصورة. حاول ثانية.",
                "errors.uploadFailed.title": "حدث خطأ أثناء التحميل",
                "errors.uploadFailed.message": "لا يمكن تحميل الصورة. حاول ثانية.",
                "errors.conversationCreate": "حدث خطأ أثناء إنشاء المحادثة. يرجى المحاولة مرة أخرى.",
                "errors.conversationInvalidId": "معرف المحادثة غير صالح.",
                "errors.conversationOpen": "خطأ في فتح المحادثة. يرجى المحاولة مرة أخرى.",
                "errors.favoriteUpdate": "فشل في تحديث المفضلة",
                "errors.blockUpdate": "لا يمكن تحديث القفل",
                "errors.messageEdit": "خطأ في تحرير الرسالة.",
                "errors.foundation_sold_out": "تم بيع أماكن المؤسس.",
                "errors.unexpected_error": "حدث خطأ غير متوقع. حاول ثانية.",
                "errors.userInactive.title": "حساب معطل",
                "errors.tenantMismatch.title": "خطأ المستأجر",
                'auth.tagline': 'قوة أن تكون مفهوماً مهما كانت اللغة',
                'auth.sign_in': 'تسجيل الدخول',
                'auth.create_account': 'إنشاء حساب',
                'ui.search_contact': 'ابحث عن جهة اتصال...',
                'ui.language': 'اللغة',
                'profile.my_profile': 'ملفي الشخصي',
                'profile.status': 'الحالة',
                'profile.invite_email': 'دعوة جهة اتصال عبر البريد الإلكتروني',
                'profile.sent_invitations': 'الدعوات المرسلة',
                "profile.users": "المستخدمين",
                'profile.settings': 'الإعدادات',
                'profile.appearance': 'المظهر',
                'profile.logout': 'تسجيل الخروج',
                'contacts.mode': 'الوضع',
                'contacts.sent': 'تم الإرسال',
                'contacts.actions': 'الإجراءات',
                'contacts.pending': 'معلق',
                'contacts.available': 'متاح',
                'contacts.invited_registered': 'مدعو - مسجّل',
                'table.email': 'البريد الإلكتروني',
                'table.language': 'اللغة',
                'table.mode': 'الوضع',
                'table.status': 'الحالة',
                'table.sent': 'أُرسلت',
                'table.actions': 'إجراءات',
  'promotions.invite.message': 'أدعوك إلى ArChat - تحدث بأي لغة. نحن على حد سواء الحصول على فوائد.',
  'promotions.progress.pending': 'لديك دعوات معلقة لفتح المكافآت.',
  'promotions.progress.in_progress': 'دعواتك قيد التقدم: يتم تنشيط المكافآت بعد محادثة حقيقية.',
  'promotions.progress.remaining': 'تحتاج إلى {count} محادثة إضافية حتى تحصل على مكافأتك.',
  'promotions.progress.sent_count': 'مرسل',
  'promotions.progress.pending_count': 'قيد الانتظار',
  'promotions.progress.in_progress_count': 'في تَقَدم',
  'promotions.progress.completed_count': 'مكتمل',
  'promotions.banner.empty': 'ابدأ الآن: قم بدعوة جهات الاتصال واحصل على المزايا.',
  'promotions.banner.pending': 'لديك دعوات معلقة: أكمل محادثة حقيقية واحصل على مكافآت.',
  'promotions.banner.reward': 'لقد قمت بالفعل بفتح المكافآت! استمر في الدعوة لزيادة مكاسبك.',
  'promotions.cta.copy': 'انسخ الرسالة والرابط',
  'promotions.cta.copied': 'تم نسخ الرسالة',
  'promotions.cta.copy_error': 'لا يمكن نسخ الرسالة',

  'promotions.title': 'الترقيات والمكافآت',
  'promotions.subtitle': 'قم بدعوة جهات الاتصال واحصل على المزايا من خلال الاستخدام الحقيقي.',
  'promotions.how_it_works': 'كيف يعمل',
  'promotions.step1': 'قم بدعوة جهة اتصال من ملفك الشخصي.',
  'promotions.step2': 'عندما يقبلون ويدردشون مع تفاعل حقيقي، يتم التحقق من صحته تلقائيًا.',
  'promotions.step3': 'يتم إضافة المكافأة ويتم تحديث تقدمك.',
  'promotions.rewards.title': 'المكافآت',
  'promotions.reward.invite': 'مكافأة لكل إحالة تم التحقق من صحتها.',
  'promotions.reward.milestone': 'مكافآت لمراحل النمو.',
  'promotions.reward.ranking': 'الظهور في أعلى تصنيفات منشئي الشبكات.',
  'promotions.progress.title': 'التقدم المحرز الخاص بك',
  'promotions.progress.sent': 'مرسل',
  'promotions.cta.invite': 'دعوة جهة اتصال',
  'promotions.banner': 'تنشيط العروض الترويجية: قم بدعوة وكسب مكافآت للاستخدام الحقيقي.',
  'promotions.modal.title': 'برنامج العروض الترويجية',
  'promotions.modal.body': 'احصل على أكثر من 10000 حرف لكل دعوة تم التحقق من صحتها بعد محادثة ثنائية حقيقية (حسب قواعد البرنامج).\\nقم بدعوة اليوم واحصل على المكافآت.',
  'promotions.modal.cta': 'عرض العروض الترويجية',
                "app.install_ios_hint": "للتثبيت: مشاركة > إضافة إلى الشاشة الرئيسية",
                'menu.promotions': 'العروض الترويجية',
                "suggestions.new": "اقتراح جديد",
                "suggestions.empty": "ليس لديك أي اقتراحات مقدمة حتى الآن.",
                "suggestions.admin_note": "ملاحظة الفريق",
                "suggestions.status.pending": "حلق",
                "suggestions.status.reviewed": "مُراجع",
                "suggestions.status.planned": "المخطط لها",
                "suggestions.status.implemented": "مُنفّذ",
                "suggestions.status.rejected": "مرفوض",
                "referral.promo": "قم بدعوة واربح 10,000 شخصية",
                "referral.stats.sent": "مرسل",
                "referral.stats.accepted": "مقبول",
                "referral.stats.rewards": "المكافآت",
                "referral.reward.pending": "حلق",
                "referral.reward.granted": "مملوء",
                "referral.reward.invalid": "غير صالح",
                "referral.reward.in_progress": "قيد الاستخدام",
                "referral.limit.reached": "تم الوصول إلى الحد الأقصى للمكافأة",
                "referral.waiting.usage": "+10000 حرف عندما ترسل أنت وضيفك رسالة نصية حقيقية واحدة على الأقل في نفس الدردشة (تم التحقق من صحة الخادم).",
                "common.avatar": "الصورة الرمزية",
                "plan.free_characters_month": "30,000 characters / month",
                "plan.pro_characters_month": "300,000 characters / month",
                "messages.empty": "لا توجد رسائل حتى الآن",
                "messages.loading": "جارٍ تحميل الرسائل...",
                "messages.connecting_server": "يتم الآن الاتصال بخادم الرسائل...",
                "messages.pending_send_count": "{count} رسالة (رسائل) في انتظار التسليم",
                "presence.custom.suggestion.coffee": "وجود بعض الاصحاب ☕",
                "presence.custom.suggestion.soccer": "في الملعب ⚽",
                "presence.custom.suggestion.working": "العمل بجنون 💪",
                "presence.custom.suggestion.lunch": "تناول الغداء🍽️",
                "presence.custom.suggestion.family": "غداء عائلي 👨‍👩‍👧‍👦",
                "presence.custom.suggestion.studying": "الدراسة📚",
                "presence.custom.suggestion.travel": "في رحلة ✈️",
                "presence.custom.suggestion.meeting": "في اللقاء 💼",
                "presence.custom.suggestion.resting": "استراحة 😴",
                "presence.custom.suggestion.gaming": "ممارسة ألعاب الفيديو 🎮",
                "presence.custom.suggestion.reading": "القراءة📖",
                "presence.custom.suggestion.offlineSoon": "سأعود حالا ⏳",
                "invitation.safe.phase_notice": "المرحلة الآمنة النشطة: الفوائد في انتظار التنشيط التجاري (لا يوجد تأثير حقيقي على الحدود).",
                "invitation.safe.generate_code": "إنشاء رابط/رمز",
                "invitation.safe.refresh_top3": "تحديث أعلى 3",
                "invitation.safe.top_loading": "جارٍ تحميل أهم المدعوين...",
                "invitation.safe.top_empty": "لا يوجد مدعوون مميزون حتى الآن.",
                "invitation.safe.hide_full_ranking": "إخفاء الترتيب الكامل",
                "invitation.safe.view_full_ranking": "انظر الترتيب الكامل",
                "invitation.safe.hide_metrics_dashboard": "إخفاء لوحة المقاييس",
                "invitation.safe.view_metrics_dashboard": "عرض لوحة المقاييس",
                "invitation.safe.prepared_link": "الرابط جاهز",
                "invitation.safe.email_placeholder": "email@dominio.com",
                "invitation.safe.register_pending": "التسجيل في انتظار الدعوة",
                "invitation.safe.status_summary": "ملخص الحالة",
                "invitation.safe.summary.pending": "الأقراط",
                "invitation.safe.summary.registered": "مسجل",
                "invitation.safe.summary.active": "نشيط",
                "invitation.safe.summary.validated": "تم التحقق من صحتها",
                "invitation.safe.summary.rejected": "مرفوض",
                "invitation.safe.sent_invitations": "الدعوات الصادرة",
                "invitation.safe.table.id": "بطاقة تعريف",
                "invitation.safe.table.invited_email": "البريد الإلكتروني للضيف",
                "invitation.safe.table.code": "شفرة",
                "invitation.safe.table.status": "ولاية",
                "invitation.safe.table.created": "مخلوق",
                "invitation.safe.empty_sent": "لم يتم إصدار أي دعوات حتى الآن.",
                "invitation.safe.simulated_rewards": "المكافآت المحاكاة المكتسبة",
                "invitation.safe.empty_rewards": "لا توجد مكافآت محاكاة في الوقت الحالي.",
                "invitation.safe.error.load_status": "تعذر تحميل حالة الدعوة.",
                "invitation.safe.error.generate_code": "لا يمكن إنشاء الرمز.",
                "invitation.safe.error.invalid_email": "أدخل بريدًا إلكترونيًا صالحًا لتسجيل الدعوة.",
                "invitation.safe.error.register_pending": "لا يمكن تسجيل الدعوة المعلقة.",
                "invitation.safe.success.code_generated": "تم إنشاء الكود بنجاح.",
                "invitation.safe.success.pending_registered": "الدعوة المعلقة مسجلة في الوضع الآمن.",
                "invitation.status.deleted": "مستبعد",
                "invitation.deleted.tooltip": "تمت إزالة هذه الدعوة",
                "invitation.status.rejected": "مرفوض",
                'invitation.status.bounced': 'مرتد',
                'invitation.status.unknown': 'حالة غير معروفة',
                "dashboard.admin.title": "مقاييس النمو",
                "dashboard.admin.newUsersToday": "مستخدمين جدد اليوم",
                "dashboard.admin.messagesSentToday": "الرسائل المرسلة اليوم",
                "dashboard.admin.translationsUsed": "الترجمات المستخدمة",
                "dashboard.admin.invitesCreated": "تم إنشاء الدعوات",
                "dashboard.admin.invitesValidated": "الدعوات المعتمدة",
                "dashboard.admin.inviteConversion": "تحويل الدعوة",
                "dashboard.admin.kFactor": "عامل K",
                "dashboard.admin.newUsers": "مستخدمين جدد",
                "dashboard.admin.messagesSent": "الرسائل المرسلة",
                "dashboard.admin.noData": "لا توجد بيانات",
                "dashboard.admin.kFactor.viral": "منتشر",
                "dashboard.admin.kFactor.stable": "مستقر",
                "dashboard.admin.kFactor.low": "قليل",
                "dashboard.admin.emailMetrics": "مقاييس البريد الإلكتروني",
                "dashboard.admin.email.sent": "مرسل",
                "dashboard.admin.email.delivered": "تم التوصيل",
                "dashboard.admin.email.opened": "يفتح",
                "dashboard.admin.email.clicked": "النقرات",
                "dashboard.admin.email.bounced": "ارتد",
                "dashboard.admin.email.deliveryRate": "معدل التسليم",
                "dashboard.admin.email.openRate": "معدل مفتوح",
                "dashboard.admin.email.bounceRate": "معدل الارتداد",
                "dashboard.admin.funnelMetrics": "مقاييس القمع",
                "dashboard.admin.funnel.registered": "مسجل",
                "dashboard.admin.funnel.confirmed": "مؤكد",
                "dashboard.admin.funnel.loggedIn": "تسجيل الدخول الأول",
                "dashboard.admin.funnel.firstMessage": "الرسالة الأولى",
                "dashboard.admin.funnel.abandoned": "متروك",
                "dashboard.admin.funnel.conversionRate": "معدل التحويل",
                "dashboard.admin.funnel.activationRate": "معدل التنشيط",
                "dashboard.admin.funnel.dropoffRate": "معدل التسرب",
                "dashboard.admin.loading": "جارٍ تحميل المقاييس...",
                "dashboard.admin.errorLoad": "تعذر تحميل لوحة معلومات المقاييس.",
                "dashboard.admin.growthViral": "النمو الفيروسي",
                "dashboard.admin.growthStable": "نمو مستقر",
                "dashboard.admin.growthLow": "نمو منخفض",
                'upgrade.price.amount': '',
                'upgrade.price.period': '',
                "upgrade.enterprise.title": "ENTERPRISE",
                "errors.modal.code": "شفرة",
                "errors.modal.message": "رسالة",
                "errors.modal.path": "طريق",
                "errors.modal.time": "ساعة",
                "errors.modal.timestamp": "الطابع الزمني",
                "errors.modal.copied": "التفاصيل المنسوخة",
                "errors.network": "تعذر الاتصال بالخادم. تحقق من اتصالك.",
                "errors.unexpected": "حدث خطأ غير متوقع. حاول ثانية.",
                "errors.boundary.title": "تم التقاط خطأ في الرد",
                "errors.boundary.request_id": "معرف الطلب X:",
                "errors.boundary.correlate": "خريطة للواجهة الخلفية/logs/structured.log",
                "errors.boundary.message_label": "رسالة:",
                "errors.boundary.stack_trace": "تتبع المكدس",
                "errors.boundary.component_stack": "مكدس المكون",
                "errors.boundary.empty": "(فارغ)",
                "errors.boundary.reload_page": "إعادة تحميل الصفحة",
                "errors.ui_boundary.refresh": "خطأ في واجهة ArChat — إعادة تحميل الصفحة",
                "bootstrap.error.title": "ArChat® — خطأ في التمهيد",
                "common.reload": "إعادة الشحن",
                "admin.access_denied.message": "رسالة",
                "admin.access_denied.title": "عنوان",
                "admin.action.change_plan": "تغيير الخطة",
                "admin.action.reactivate": "إعادة التنشيط",
                "admin.action.suspend": "تعليق",
                "admin.action.view": "منظر",
                "admin.confirm.change_plan.message": "رسالة",
                "admin.confirm.change_plan.title": "عنوان",
                "admin.confirm.suspend.message": "رسالة",
                "admin.confirm.suspend.title": "عنوان",
                "admin.details.created": "مخلوق",
                "admin.details.current_plan": "الخطة الحالية",
                "admin.details.domain": "اِختِصاص",
                "admin.details.last_activity": "النشاط الأخير",
                "admin.details.name": "بطاطا",
                "admin.details.plan": "يخطط",
                "admin.details.status": "حالة",
                "admin.details.subscription": "الاشتراك",
                "admin.details.tenant_id": "معرف المستأجر",
                "admin.details.tenant_info": "معلومات المستأجر",
                "admin.details.usage": "الاستخدام",
                "admin.error.change_plan": "تغيير الخطة",
                "admin.error.generic": "نوعي",
                "admin.error.load_details": "تفاصيل التحميل",
                "admin.error.load_tenants": "تحميل المستأجرين",
                "admin.error.reactivate": "إعادة التنشيط",
                "admin.error.suspend": "تعليق",
                "admin.error.title": "عنوان",
                "admin.filter.active": "فعل",
                "admin.filter.all_plans": "جميع الخطط",
                "admin.filter.all_status": "كل الوضع",
                "admin.filter.suspended": "تعليق",
                "admin.limit.devices": "الأجهزة",
                "admin.limit.invitations": "الدعوات",
                "admin.limit.messages": "رسائل",
                "admin.limit.storage": "تخزين",
                "admin.limit.users": "المستخدمين",
                "admin.loading": "تحميل",
                "admin.no_tenants": "غير المستأجرين",
                "admin.plan.enterprise": "Enterprise",
                "admin.plan.free": "Free",
                "admin.plan.pro": "Pro",
                "admin.status.active": "فعل",
                "admin.status.suspended": "تعليق",
                'admin.subscription.id': 'Id',
                "admin.subscription.last_payment": "الدفعة الأخيرة",
                "admin.subscription.status": "حالة",
                "admin.subtitle": "الترجمة",
                "admin.success.plan_changed": "تغيرت الخطة",
                "admin.success.tenant_reactivated": "تم إعادة تنشيط المستأجر",
                "admin.success.tenant_suspended": "المستأجر موقوف",
                "admin.success.title": "عنوان",
                "admin.table.actions": "الإجراءات",
                "admin.table.messages": "رسائل",
                "admin.table.name": "بطاطا",
                "admin.table.plan": "يخطط",
                "admin.table.status": "حالة",
                "admin.table.storage": "تخزين",
                "admin.table.tenant_id": "معرف المستأجر",
                "admin.table.users": "المستخدمين",
                "admin.title": "عنوان",
                "admin.usage.devices": "الأجهزة",
                "admin.usage.invitations": "الدعوات",
                "admin.usage.messages": "رسائل",
                "admin.usage.storage": "تخزين",
                "admin.usage.users": "المستخدمين",
                "auth.login": "تسجيل الدخول",
                "auth.register": "يسجل",
                "auth.reset_password": "إعادة تعيين كلمة المرور",
                "billing.cancel.button": "زر",
                "billing.cancel.canceling": "الإلغاء",
                "billing.cancel.confirm": "يتأكد",
                "billing.cancel.error": "خطأ",
                "billing.cancel.success": "نجاح",
                "billing.character_billing.characters_used": "الشخصيات المستخدمة",
                "billing.character_billing.consumption_pct": "نسبة الاستهلاك",
                "billing.character_billing.days_remaining": "الأيام المتبقية",
                "billing.character_billing.deletion_date": "تاريخ الحذف",
                "billing.character_billing.period_start": "بداية الدورة الشهرية",
                "billing.character_billing.renewal_date": "تاريخ التجديد",
                "billing.character_billing.title": "عنوان",
                "billing.current_plan": "الخطة الحالية",
                "billing.founder_badge": "شارة المؤسس",
                "billing.no_plans": "لا تخطط",
                'billing.subscription.canceled': 'Canceled',
                'billing.subscription.canceled_note': 'Canceled note',
                "billing.subscription.next_payment": "الدفعة القادمة",
                "billing.subscription.plan": "يخطط",
                'billing.subscription.price': 'سعر الخطة',
                "billing.subscription.started": "بدأت",
                "billing.subscription.status": "حالة",
                'billing.subscription.mp_flow.subscribe_failed': 'تعذر بدء الاشتراك. يُرجى المحاولة مرة أخرى.',
                'billing.subscription.mp_flow.change_plan_failed': 'تعذر تغيير الخطة. يُرجى المحاولة مرة أخرى.',
                'billing.subscription.mp_status.pending': 'قيد الانتظار',
                'billing.subscription.mp_status.authorized': 'مُخوَّل',
                'billing.subscription.mp_status.active': 'نشط',
                'billing.subscription.mp_status.paused': 'مُعلَّق',
                'billing.subscription.mp_status.cancelled': 'ملغى',
                'billing.subscription.mp_status.inactive': 'غير نشط',
                'billing.subscription.mp_status.unknown': 'غير معروف',
                "billing.unlimited": "غير محدود",
                "billing.update_plan": "تحديث الخطة",
                "billing.update_plan_modal.title": "عنوان",
                "billing.usage.loading": "تحميل",
                "common.accept": "يقبل",
                "common.confirmPassword": "تأكيد كلمة المرور",
                "common.error": "خطأ",
                "dashboard.upgrade.to_plan": "للتخطيط",
                "emoji.noResults": "لا توجد نتائج",
                "emoji.pick": "يختار",
                "export.restricted.message": "رسالة",
                "export.restricted.title": "عنوان",
                "export.restricted.upgrade": "يرقي",
                "founder.*": "*",
                "help.faq.a1": "أ1",
                "help.faq.a2": "أ2",
                "help.faq.a3": "أ3",
                "help.faq.a4": "A4",
                "help.faq.a5": "أ5",
                "help.faq.a6": "أ6",
                "help.faq.a7": "أ7",
                "help.faq.q1": "س1",
                "help.faq.q2": "س2",
                "help.faq.q3": "س3",
                "help.faq.q4": "س 4",
                "help.faq.q5": "س5",
                "help.faq.q6": "س6",
                "help.faq.q7": "س7",
                "help.faq.title": "عنوان",
                "help.howWorks.step4.point7": "النقطة7",
                "help.message_time_context.free_vs_pro": "مجاني مقابل محترف",
                "help.message_time_context.point5": "النقطة5",
                "help.plans.enterprise.benefits": "فوائد",
                "help.plans.enterprise.description": "وصف",
                "help.plans.enterprise.title": "عنوان",
                "help.plans.foundation.devices": "الأجهزة",
                "help.plans.free.description": "وصف",
                "help.plans.free.devices": "الأجهزة",
                "help.plans.free.limits": "حدود",
                "help.plans.free.title": "عنوان",
                "help.plans.intro": "مقدمة",
                "help.plans.pro.benefits": "فوائد",
                "help.plans.pro.description": "وصف",
                "help.plans.pro.devices": "الأجهزة",
                'help.plans.pro.price': '$19 / شهر',
                "help.plans.pro.title": "عنوان",
                "help.plans.pro.upgrade": "يرقي",
                "help.plans.title": "عنوان",
                "help.plans.urgent_slots_badge": "شارة فتحات عاجلة",
                "help.slogan.final": "نهاية",
                "help.suggestions.point1": "النقطة1",
                "help.suggestions.point2": "النقطة2",
                "help.suggestions.title": "عنوان",
                "invitation.already_contact_added": "تمت إضافة جهة الاتصال بالفعل",
                "invitation.already_contact_title": "عنوان الاتصال بالفعل",
                "invitation.already_pending": "معلقة بالفعل",
                "invitation.language.invalid": "غير صالح",
                "message.send": "يرسل",
                "message.sendFile": "إرسال ملف",
                "messages.conversations": "المحادثات",
                "messages.no_conversations_subtitle": "لا يوجد عنوان فرعي للمحادثات",
                "messages.no_conversations_title": "لا يوجد عنوان للمحادثات",
                "presence.custom.edit": "يحرر",
                "profile.enrichment.country": "دولة",
                "profile.enrichment.country.select": "يختار",
                "profile.enrichment.description": "وصف",
                "profile.enrichment.org_size": "حجم المنظمة",
                "profile.enrichment.org_size.placeholder": "حامل مكان",
                "profile.enrichment.save": "يحفظ",
                "profile.enrichment.skip": "يتخطى",
                "profile.enrichment.title": "عنوان",
                "profile.enrichment.usage_type.label": "ملصق",
                "profile.enrichment.usage_type.placeholder": "حامل مكان",
                "profile.founderPosition": "موقف المؤسس",
                "settings.confirmations.description": "وصف",
                "settings.confirmations.disable": "إبطال",
                "settings.confirmations.title": "عنوان",
                "settings.confirmations.updated": "تم التحديث",
                "settings.title": "عنوان",
                "theme.description": "وصف",
                "google.unavailable_tenant": "Google غير متاح لهذا المستأجر.",
                "google.unavailable": "جوجل غير متوفر.",
                "google.verify_client_id": "تحقق من معرف العميل في Google Cloud Console.",
                'google.login_aria': 'تسجيل الدخول باستخدام Google',
                "message.preview_alt": "معاينة",
                "message.image_attachment_alt": "الصورة المرفقة",
                "profile.avatar.alt": "الصورة الرمزية",
                "plan.name.free": "FREE",
                "plan.name.pro": "PRO",
                "plan.name.foundation": "FOUNDATION",
                "plan.name.enterprise": "ENTERPRISE",
                "register.emailPlaceholder": "you@email.com",
                "invitation.top.loading": "جارٍ تحميل أهم المدعوين...",
                "invitation.top.empty": "لا يوجد مدعوين مميزين حتى الآن.",
                "invitation.contacts.title": "دعوة جهات الاتصال",
                "invitation.contacts.safe_phase_note": "المرحلة الآمنة نشطة: الفوائد المعلقة دون التأثير على الحدود الحقيقية.",
                "invitation.contacts.generate_code": "إنشاء رمز/رابط",
                "invitation.contacts.refresh_top3": "تحديث أعلى 3",
                "invitation.contacts.hide_full_ranking": "إخفاء الترتيب الكامل",
                "invitation.contacts.show_full_ranking": "عرض الترتيب الكامل",
                "invitation.contacts.hide_metrics_dashboard": "إخفاء لوحة المقاييس",
                "invitation.contacts.show_metrics_dashboard": "عرض لوحة المقاييس",
                "invitation.contacts.prepared_link_label": "الرابط المجهز:",
                "invitation.contacts.email_placeholder": "email@domain.com",
                "invitation.contacts.register_pending": "التسجيل في انتظار الدعوة",
                "invitation.contacts.status_summary": "ملخص الحالة",
                "invitation.contacts.sent_invitations": "الدعوات المرسلة",
                "invitation.contacts.invited_email": "البريد الإلكتروني المدعو",
                "invitation.contacts.code": "شفرة",
                "invitation.contacts.no_sent_invitations": "لم أرسل الدعوات بعد.",
                "invitation.contacts.simulated_rewards": "تم الحصول على مكافآت محاكاة",
                "invitation.contacts.no_simulated_rewards": "لا توجد مكافآت محاكاة حتى الآن.",
                "common.id": "بطاقة تعريف",
                "common.created": "مخلوق",
                'plan.pro_contacts': 'حتى 100 جهة اتصال لكل مستخدم',
                "common.status": "حالة",
                "login.prompt_create_account_with_name": "هل تريد إنشاء حساب بهذا الاسم؟",
                'plans.upgrade.title': 'ترقية الخطة',
                'plans.upgrade.comparison': 'مقارنة الخطط',
                'plans.upgrade.billing': '',
                'plans.upgrade.cancel_anytime': 'يمكنك الإلغاء في أي وقت',
                'plans.actions.upgrade_pro': 'الترقية إلى PRO',
                'plans.actions.become_founder': 'كن Founder',

                'plans.modal.card.current_badge': 'خطتك الحالية',

                'plans.modal.card.lower_tier': 'أقل من خطتك النشطة',

                'plans.modal.card.manage_in_profile': 'للتغيير أو الإلغاء: الاشتراك والفوترة في ملفك الشخصي.',
                'plans.modal.card.cancel_subscription': 'إلغاء الاشتراك',
                'plans.modal.cancel_confirm.title': 'إلغاء الاشتراك أو إدارته',
                'plans.modal.cancel_confirm.body': 'سيفتح تبويب جديد بوابة Paddle الآمنة لتحديث الدفع أو الفواتير أو إلغاء الاشتراك.',
                'plans.modal.cancel_confirm.continue_button': 'متابعة',
                'plans.modal.cancel_confirm.back_button': 'رجوع',
                'plans.modal.cancel_paddle_fallback.title': 'إدارة الاشتراك',
                'plans.modal.cancel_paddle_fallback.body': 'لا يُفتح بوابة Paddle للفوترة في هذا البيئة (مثل التطوير المحلي أو عدم الربط). يمكنك متابعة عرض ومقارنة الخطط هنا.',
                'plans.modal.cancel_paddle_fallback.confirm': 'تم',
                'plans.upgrade_required': 'متاح في خطة PRO',
                'settings.heading': 'الإعدادات',
                'settings.dashboard': 'لوحة',
                'settings.dashboardDescription': 'تفضيلات محلية للوحة الرئيسية والعناصر الظاهرة.',
                'settings.dashboardGridHeading': 'كتل اللوحة',
                'settings.dashboardShowOnStartDescription': 'عند التفعيل تُفتح اللوحة بعد تسجيل الدخول بدل قائمة جهات الاتصال.',
                'settings.dashboardBlockWelcome': 'ترحيب',
                'settings.dashboardBlockUsage': 'استخدام الخطة',
                'settings.dashboardBlockFiles': 'ملفاتي',
                'settings.dashboardBlockPromotions': 'عروض',
                'settings.dashboardBlockSessions': 'جلسات',
                'settings.dashboardWelcomeDescription': 'الخطوات الأولى ودعوة جهة وروابط المساعدة.',
                'settings.dashboardUsageDescription': 'الاستخدام مقارنة بالحدود: جهات، أحرف، تخزين، أجهزة.',
                'settings.dashboardFilesDescription': 'ملخص الملفات الظاهرة والمساحة في «ملفاتي».',
                'settings.dashboardPromotionsDescription': 'ملخص العروض والرابط للبرنامج.',
                'settings.dashboardSessionsDescription': 'الجلسات والأجهزة النشطة؛ إمكانية إغلاق الجلسات الأخرى إن وُجدت.',
                'settings.enabled': 'مفعّل',
                'settings.disabled': 'غير مفعّل',
                'settings.showDashboardOnStart': 'إظهار اللوحة عند الدخول',
                'settings.showWelcomeBlock': 'قسم الترحيب',
                'settings.showPromotionsBlock': 'قسم العروض',
                'settings.showUsageBlock': 'قسم الاستخدام',
                'settings.showRecentConversationsBlock': 'عرض المحادثات الأخيرة (آخر رسالة لكل جهة)',
                'settings.showSessionsBlock': 'قسم الجلسات',
                'settings.showFilesBlock': 'قسم الملفات',
                'settings.dashboardLocalNote': 'يُحفظ محلياً في هذا المتصفح حتى تتوفر واجهة تفضيلات في الملف الشخصي.',
                'settings.appearanceSettings': 'المظهر',
                'settings.argentinaTheme': 'سمة الأرجنتين',
                'settings.darkMode': 'الوضع الداكن',
                'settings.language': 'اللغة',
                'settings.messageSound': 'صوت الرسائل',
                'settings.playSoundDescription': 'تشغيل صوت للرسائل الجديدة أو التنبيهات المهمة.',
                'settings.messageSoundEnabled': 'تشغيل',
                'settings.messageSoundDisabled': 'إيقاف',
                'settings.accountSettings': 'الحساب',
                'settings.deleteAccount': 'حذف الحساب',
                'settings.deleteAccountWarning': 'هذا الإجراء نهائي. ستُزال بياناتك ورسائلك وجهات اتصالك وإعداداتك وفق عملية الحذف في المنصة.',
                'settings.deleteMyAccount': 'احذف حسابي',
                'dashboard.contacts': 'جهات الاتصال',
                'dashboard.characters': 'الأحرف',
                'dashboard.storage': 'التخزين',
                'dashboard.active_devices': 'الأجهزة النشطة',
                'dashboard.need_more_resources': 'هل تحتاج إلى المزيد من الموارد؟',
                'dashboard.upgrade_message': 'قم بترقية خطتك للحصول على المزيد من جهات الاتصال والأحرف والتخزين والأجهزة النشطة.',
                'dashboard.upgrade_button': 'الترقية إلى PRO',
                'dashboard.upgrade_button_pro': 'الترقية إلى PRO',
                'dashboard.upgrade_button_foundation': 'الترقية إلى FOUNDATION',
                'files.preview': 'معاينة',
                'files.previewFile': 'معاينة الملف',
                'files.previewUnavailable': 'المعاينة غير متاحة.',
                'files.previewLoading': 'جارٍ تحميل المعاينة…',
                'files.openPreview': 'معاينة',
                'files.downloadFile': 'تنزيل الملف',
                'files.downloadFailed': 'تعذر تنزيل الملف. تحقق من الاتصال والجلسة ثم أعد المحاولة.',
                'files.closePreview': 'إغلاق المعاينة',
                'files.unsupportedPreview': 'لا توجد معاينة لهذا النوع. يمكنك عرض التفاصيل أو التنزيل.',
                'files.pdfPreviewHelp': 'قد لا يعرض المتصفح ملف PDF المضمّن. استخدم التنزيل لفتحه.',
                'files.labelFileType': 'النوع',
                'files.previewForbidden': 'لا يوجد إذن للمعاينة.',
                'files.previewNotFound': 'الملف غير متاح أو لم يعد يظهر في حسابك.',
                'files.unavailableForFree': '«ملفاتي» غير متضمنة في خطة FREE.',
                'files.availableInFoundationAndPro': '«ملفاتي» متاحة في ختي FOUNDATION وPRO.',
                'files.filesFeatureRestricted': 'هذه الميزة غير متوفرة في خطتك الحالية.',
                'files.filesLoadError': 'حدث خطأ أثناء تحميل الملفات.',
                'files.uploadUnavailableForFree': 'إرسال الملفات غير متاح في خطة FREE.',
                'files.uploadAvailableInFoundationAndPro': 'إرسال الملفات متاح في FOUNDATION وPRO.',
                'files.recipientStorageFull': 'ليس لدى المستلم مساحة كافية لاستلام هذا الملف.',
                'files.recipientNoAvailableStorage': 'ليس لدى المستلم مساحة كافية لاستلام هذا الملف.',
                'files.storageQuotaExceeded': 'لقد وصلت إلى حد تخزين خطتك.',
                'files.freeStorageLimit': 'تتضمن خطة FREE 5 ميغابايت للملفات المستلمة.',
                'settings.unreadEmailReminderSection': 'ملخص غير المقروء عبر البريد',
                'settings.unreadEmailReminderDescription': 'إذا تركت رسائل أو ملفات جديدة دون قراءة أطول من الوقت أدناه، يرسل ArChat بريداً واحداً مجمعاً (وليس بريداً لكل رسالة).',
                'settings.unreadEmailReminderToggle': 'أرسل الملخصات إلى بريدي',
                'settings.unreadEmailDelayHours': 'الانتظار قبل الإرسال (ساعات)',
                'settings.unreadEmailDelayHint': '1–168 ساعة (حتى أسبوع). لغة البريد من الملف الشخصي.',
                'subjects.title': 'المواضيع',
                'subjects.singular': 'موضوع',
                'subjects.plural': 'مواضيع',
                'subjects.general': 'عام',
                'subjects.new': 'موضوع جديد',
                'subjects.create': 'إنشاء موضوع',
                'subjects.rename': 'إعادة تسمية',
                'subjects.finish': 'إنهاء',
                'subjects.reopen': 'إعادة فتح',
                'subjects.select': 'متابعة',
                'subjects.status.open': 'مفتوح',
                'subjects.status.pending': 'قيد الانتظار',
                'subjects.status.finished': 'منتهٍ',
                'subjects.limitReached': 'بلغت الحد الأقصى للمواضيع النشطة في هذه المحادثة. أنهِ موضوعًا لإنشاء موضوع آخر.',
                'subjects.limitReachedFree': 'خطة FREE: حتى 3 مواضيع نشطة لكل محادثة. أنهِ موضوعًا لإنشاء موضوع آخر.',
                'subjects.limitReachedPro': 'خطة PRO: حتى 5 مواضيع نشطة لكل محادثة. أنهِ موضوعًا لإنشاء موضوع آخر.',
                'subjects.limitReachedFoundation': 'خطة FOUNDATION: حتى 5 مواضيع نشطة لكل محادثة. أنهِ موضوعًا لإنشاء موضوع آخر.',
                'subjects.activeLimitsLine': 'المواضيع النشطة: {current} / {max}',
                'subjects.closedListTitle': 'مواضيع مغلقة',
                'subjects.viewClosed': 'عرض المواضيع المغلقة',
                'subjects.noClosedSubjects': 'لا توجد مواضيع مغلقة.',
                'subjects.reopenSubject': 'إعادة الفتح',
                'subjects.reopenedSubjects': 'مواضيع أعيد فتحها',
                'subjects.reopenLimitReached':
                  'لقد وصلت إلى حد المواضيع النشطة. أنهِ موضوعًا آخر لإعادة فتح هذا الموضوع.',
                'subjects.ownerOnlyReopen': 'يمكن لمن أنشأ هذا الموضوع فقط إعادة فتحه.',
                'subjects.modal.title': 'مواضيع المحادثة',
                'subjects.modal.subtitle': 'اختر أو أدر مواضيع هذه المحادثة.',
                'subjects.contactLabel': 'جهة الاتصال:',
                'subjects.ownerOnlyRename': 'يمكن فقط لمن أنشأ الموضوع تغيير اسمه.',
                'subjects.ownerOnlyStateChange': 'يمكن فقط لمن أنشأ الموضوع تغيير حالته.',
                'subjects.createdByOther': 'أنشأ الطرف الآخر هذا الموضوع. يمكنك الرد ولكن لا يمكنك إعادة تسميته.',
                'subjects.empty': 'لا توجد مواضيع للعرض.',
                'subjects.noResults': 'لم يتم العثور على مواضيع.',
                'subjects.error.generic': 'تعذر إكمال الإجراء. حاول مرة أخرى.',
                'subjects.error.featureDisabled': 'المواضيع غير متاحة في هذه البيئة.',
                'subjects.error.duplicateName': 'يوجد بالفعل موضوع نشط بهذا الاسم.',
                'subjects.error.ownerRequired': 'ليست لديك صلاحية لتعديل هذا الموضوع.',
                'subjects.error.defaultCannotRename': 'لا يمكن إعادة تسمية الموضوع العام.',
                'subjects.error.defaultCannotFinish': 'لا يمكن إنهاء الموضوع العام.',
                'subjects.current': 'الموضوع',
                'subjects.change': 'تغيير الموضوع',
                'subjects.currentLabel': 'الموضوع:',
                'subjects.changeSubject': 'تغيير الموضوع',
                'subjects.closedCannotSend': 'هذا الموضوع منتهٍ. أعد فتحه لإرسال رسائل جديدة.',
                'subjects.selectBeforeSend': 'اختر موضوعًا في النافذة لعرض الرسائل والإرسال.',
                'subjects.loadingMessages': 'جاري تحميل رسائل هذا الموضوع…',
                'subjects.messageFilterError': 'تعذر تحميل رسائل هذا الموضوع.',
                ...PRESET_LOCALES.ar,
                "auth.login.clear_password_lock_after_reset": "لقد قمت بالفعل بتغيير كلمة المرور الخاصة بي (على سبيل المثال، على جهاز آخر)",
                "auth.signup_disabled": "تم تعطيل تسجيل الحساب الجديد مؤقتًا في هذه البيئة.",
                "auth.reset_user_not_found": "لم نعثر على حساب مرتبط بهذا البريد الإلكتروني. تأكد من كتابته بشكل صحيح أو قم بإنشاء حساب جديد.",
                "account.not_found": "لم يتم العثور على الحساب.",
                "auth.pending_activation.title": "الحساب في انتظار التنشيط",
                "auth.pending_activation.body": "لم يتم تفعيل حسابك بعد. تحقق من بريدك الإلكتروني وأكد تسجيلك للدخول إلى ArChat.",
                "auth.pending_activation.back_to_login": "العودة إلى تسجيل الدخول",
                "auth.pending_activation.support_prefix": "هل تحتاج إلى مساعدة؟ الاتصال بالدعم:",
                "auth.pending_activation.support_email": "info@archat.com.ar",
                "auth.pending_activation.email_label": "البريد الإلكتروني لإعادة إرسال التنشيط",
                "auth.pending_activation.email_placeholder": "tu@email.com",
                "auth.pending_activation.email_required": "أدخل البريد الإلكتروني الذي قمت بالتسجيل به لإعادة إرسال التنشيط.",
                "auth.pending_activation.sent_title": "تم إرسال بريد التنشيط",
                "auth.pending_activation.sent_body": "إذا كان البريد الإلكتروني يتوافق مع حساب معلق، فسنرسل لك رابط تفعيل جديد. تحقق من صندوق الوارد الخاص بك وكذلك البريد العشوائي أو البريد غير الهام.",
                "auth.pending_activation.soft_error_title": "إعادة الإرسال غير متوفرة",
                "auth.pending_activation.soft_error_body": "لم نتمكن من معالجة إعادة الإرسال في هذا الوقت. حاول مرة أخرى خلال بضع دقائق أو راسلنا على info@archat.com.ar.",
                "auth.pending_activation.resend_again": "إعادة إرسال مرة أخرى",
                "menu.plans": "الخطط",
                "files.title": "ملفاتي",
                "files.filter_all": "الجميع",
                "files.filter_sent": "مرسل",
                "files.filter_received": "تلقى",
                "files.filter_images": "الصور",
                "files.filter_documents": "وثائق",
                "files.col_name": "اسم",
                "files.col_size": "مقاس",
                "files.col_date": "تاريخ",
                "files.col_direction": "دير.",
                "files.col_actions": "الإجراءات",
                "files.sent": "📤 تم الإرسال",
                "files.received": "📥 تم الاستلام",
                "files.download": "تسريح",
                "files.delete_for_me": "حذف بالنسبة لي",
                "files.delete_confirm_title": "حذف الملف",
                "files.delete_confirm_message": "سيتم حذف هذا الملف من حسابك. ولن يتم حذفه بالنسبة للشخص الآخر. يكمل؟",
                "files.empty": "ليس لديك ملفات.",
                "files.error_loading": "خطأ في تحميل الملفات.",
                "files.load_more": "تحميل المزيد",
                "message.status.sending": "إرسال…",
                "message.status.failed": "لم يتم إرسالها",
                "message.status.sent": "مرسل",
                "message.status.delivered": "تم التوصيل",
                "message.status.read": "يقرأ",
                "home.public_nav.pricing": "الأسعار",
                "home.public_nav.aria": "التنقل في الموقع الرئيسي",
                "home.public_footer.aria": "الروابط القانونية",
                "home.pricing_link": "الخطط والأسعار",
                "publicPricing.nav.back_home": "← الصفحة الرئيسية",
                "publicPricing.title": "الخطط والأسعار",
                "publicPricing.subtitle": "حدود شفافة ومتوافقة مع محرك اشتراك ArChat. الأسعار التجارية بالدولار الأمريكي للسداد الدولي (مثل Paddle).",
                "publicPricing.commercial_note": "الحدود الوظيفية تأتي من PlanConstants/PlanResolver؛ يمكن لحسابك تطبيق Plan_limits في قاعدة البيانات. تستخدم رسوم التاجر Paddle (أو المعالجات الأخرى المعينة رسميًا بواسطة ArChat) بسعر الدولار الأمريكي كما هو محدد.",
                "publicPricing.plan.free": "FREE",
                "publicPricing.plan.foundation": "FOUNDATION",
                "publicPricing.plan.pro": "PRO",
                "publicPricing.price.free": "USD 0 / mes",
                "publicPricing.price.foundation": "USD {price} / mes",
                "publicPricing.price.pro": "USD {price} / mes",
                "publicPricing.same_limits_pro": "نفس الحدود الفنية مثل PRO (العقد المميز).",
                "publicPricing.same_limits_foundation": "نفس الحدود الفنية مثل FOUNDATION (عقد مميز).",
                "publicPricing.badge.foundation": "Programa Founder",
                "publicPricing.badge.pro": "Recomendado",
                "publicPricing.free.b1": "30.000 حرف شهريًا لكل حساب.",
                "publicPricing.free.b2": "ما يصل إلى جهتي اتصال لكل مستخدم؛ ما يصل إلى محادثتين نشطتين لكل حساب.",
                "publicPricing.free.b3": "لا توجد مرفقات أو مساحة تخزين؛ بدون تصدير البيانات.",
                "publicPricing.free.b4": "سجل الرسائل حتى 30 يومًا؛ جهاز واحد لكل مستخدم.",
                "publicPricing.free.b5": "34 رسالة/اليوم و1000 رسالة/الشهر (المستأجر)؛ ما يصل إلى 20 دعوة يوميا.",
                "publicPricing.premium.b1": "300.000 حرف شهريًا لكل حساب؛ ما يصل إلى 100 جهة اتصال لكل مستخدم.",
                "publicPricing.premium.b2": "محادثات ودردشات غير محدودة (المستأجر)؛ 1,667 رسالة/اليوم و50,000/الشهر.",
                "publicPricing.premium.b3": "مساحة تخزين تصل إلى 50 ميجابايت (المستأجر)؛ ما يصل إلى 3 أجهزة لكل مستخدم.",
                "publicPricing.premium.b4": "دعوات غير محدودة (المستأجر)؛ التصدير والترجمة الآلية والملفات حسب الخطة.",
                "publicPricing.premium.b5": "التأسيس: نفس العقد الفني المبرم مع PRO، بالإضافة إلى برنامج المؤسس (150 مكانًا). PRO: معيار ممتاز.",
                "publicPricing.foundation.founder_note": "البرنامج التجاري للمؤسس: عدد محدود من الأماكن {الفتحات} (راجع ملخص الخطة). نفس حدود PRO بمجرد تنشيط الاشتراك.",
                "publicPricing.cta.start_free": "إنشاء حساب مجاني",
                "publicPricing.cta.register_paid": "إنشاء حساب",
                "publicPricing.paddle_hint": "سيتم إكمال عملية الدفع باستخدام المعالج المختار داخل التطبيق عند تمكين الشحن.",
                "publicPricing.legal.nav_label": "قانوني",
                "publicPricing.legal.terms": "شروط الخدمة",
                "publicPricing.legal.privacy": "سياسة الخصوصية",
                "publicPricing.legal.refund": "سياسة استرداد الأموال",
                "profile.security.privacy_note": "إدارة خصوصية وأمان حسابك.",
                "profile.security.sessions_title": "جلسات نشطة",
                "profile.security.current": "الجلسة الحالية",
                "profile.plan.foundation.description": "خطة التأسيس (المؤسس): نفس الاستخدام المتميز مثل PRO، مع برنامج المؤسس ومساحة محدودة (150 مقعدًا).",
                "billing.view_plans": "انظر الخطط",
                "billing.paddle.cancel_via_portal": "إلغاء الاشتراك",
                "billing.paddle.test_access_denied_body": "على هذا الخادم، تكون عمليات الفوترة مقيدة (وضع الاختبار أو قائمة الاختبار). إذا كنت قد دفعت بالفعل باستخدام حساب حقيقي، فيجب السماح بالدفع في مرحلة الإنتاج لجميع المستخدمين (على سبيل المثال، PAYMENTS_ALLOW_ALL_BILLING_USERS) أو يجب تعطيل هذا التقييد. اتصل بالدعم.",
                "attachment.storage_insufficient_precheck.title": "مساحة غير كافية",
                "attachment.storage_insufficient_precheck.message": "يزن الملف {fileSizeMb} ميغابايت ولا يتوفر لديك سوى {availableMb} ميغابايت. قم بإخلاء مساحة أو تحسين خطتك للمتابعة.",
                "attachment.files_disabled.title": "حد الخطة",
                "attachment.files_disabled.message": "خطتك الحالية لا تتضمن إرسال الملفات. قم بتحسين خطتك للمتابعة.",
                "contacts.viewContactInfo": "عرض تفاصيل الاتصال",
                "contacts.contactInfoTitle": "تفاصيل الاتصال",
                "contacts.phone": "هاتف",
                "contacts.bio": "سيرة",
                "contacts.notProvided": "غير مطلعين",
                "contacts.unread.badge": "رسائل غير مقروءة",
                "dashboard.plan.foundation": "FOUNDATION",
                "plan.errors.translationNotAllowed.title": "الترجمة غير متوفرة",
                "plan.errors.translationNotAllowed.message": "خطتك الحالية لا تتضمن الترجمة الآلية بين اللغات.",
                "plan.errors.translationNotAllowed.solution": "لاستخدام الترجمة الآلية، قم بترقية خطتك.",
                "billing.subscription.cancel_scheduled_date": "تمت جدولة اشتراكك للإلغاء في {{date}}. يمكنك الاستمرار في استخدام خطتك حتى ذلك الحين.",
                "billing.subscription.cancel_scheduled_badge": "تم الإلغاء في {{date}}",
                "billing.scheduled.plan_after_cancel_label": "الخطة في نهاية الفترة:",
                "billing.scheduled.plan_free": "FREE (gratuito)",
                "billing.scheduled.plan_foundation": "FOUNDATION",
                "billing.scheduled.switch_to_foundation": "التغيير إلى الأساس",
                "billing.scheduled.switch_to_free": "التغيير إلى مجاني",
                "billing.scheduled.foundation_full_title": "الأساس غير متوفر",
                "billing.scheduled.foundation_full_message": "لا توجد أماكن FOUNDATION متاحة في هذا الوقت. ستصبح خطتك مجانية في نهاية الفترة.",
                "billing.scheduled.saving": "توفير...",
                "billing.scheduled.error_title": "حدث خطأ أثناء تغيير الخطة",
                "billing.scheduled.error_generic": "لا يمكن تغيير الخطة المجدولة. حاول ثانية.",
                "billing.cancel_scheduled.title": "الإلغاء المقرر",
                "billing.cancel_scheduled.desc": "سيتم إلغاء اشتراكك في {{date}}. يمكنك الاستمرار في استخدام خطتك الحالية حتى ذلك الحين.",
                "billing.cancel_scheduled.no_new_plan_until_end": "وإلى أن تنتهي صلاحية هذا الاشتراك، لن تتمكن من التعاقد على خطة أخرى.",
                "billing.cancel_scheduled.free_fallback": "إذا لم تقم بتجديد أي خطة، فسيستمر حسابك مجانًا مع القيود المقابلة.",
                "billing.cancel_scheduled.profile_deactivation_hint": "يمكنك أيضًا إلغاء الاشتراك في المنصة من ملفك الشخصي.",
                "billing.cancel_scheduled.default_free": "في نهاية الفترة: مجاناً",
                "google.missing_client_id": "تسجيل الدخول إلى Google غير متاح في هذا الإصدار: VITE_GOOGLE_CLIENT_ID (أو googleClientId لكل مستأجر في __ARCHAT_TENANT_CONFIG__) مفقود.",
                "reviews.title": "تقييمات آرتشات",
                "reviews.create_title": "كيف تقيم آرتشات؟",
                "reviews.edit_title": "تحرير تقييمي",
                "reviews.comment_placeholder": "أخبرنا عن تجربتك (اختياري)...",
                "reviews.submit_btn": "إرسال المراجعة",
                "reviews.update_btn": "تحديث",
                "reviews.thank_you": "شكرا لمراجعتك!",
                "reviews.submitted_message": "رأيك يساعدنا على التحسن.",
                "reviews.error_select_rating": "حدد التقييم",
                "reviews.error_generic": "حدث خطأ أثناء إرسال المراجعة",
                "reviews.prompt_message": "هل تحب آرتشات؟ اترك رأيك!",
                "reviews.rate_now": "تأهل",
                "reviews.later": "لاحقاً",
                "reviews.write_review": "اكتب مراجعة",
                "reviews.edit_my_review": "تحرير تقييمي",
                "reviews.no_reviews": "لا توجد تعليقات حتى الآن. كن الأول!",
                "reviews.review_singular": "مراجعة",
                "reviews.review_plural": "مراجعات",
                "reviews.verified": "تم التحقق منه",
                "reviews.anonymous": "مجهول",
                "files.storageUsed": "المساحة المستعملة",
                "files.planQuota": "حصة الخطة",
                "files.availableStorage": "متاح",
                "files.usagePercent": "مستخدم",
                "files.unlimited": "غير محدود",
                "files.sentBy": "أرسلت بواسطة",
                "files.unknownUser": "مستخدم",
                "settings.webPushSection": "إشعارات النظام (دفع/PWA)",
                "settings.webPushDescription": "يسمح بالإشعارات عندما يكون التطبيق في الخلفية أو مغلقًا على الهاتف المحمول. يتطلب مفتاح VAPID العام في الإصدار (VITE_VAPID_PUBLIC_KEY) ومفاتيح على الخادم. قم بتنشيط إذن المتصفح وتسجيل هذا الجهاز.",
                "settings.webPushButton": "تفعيل دفع الإخطارات",
                "settings.webPushRegistering": "جارٍ التسجيل…",
                "settings.webPushState.granted": "تم منح الإذن. إذا تم تعيين VAPID بشكل صحيح، فسيتم إرسال السجل إلى الخادم.",
                "settings.webPushState.denied": "تم رفض الإذن. يرجى تمكين الإشعارات لهذا الموقع في إعدادات المتصفح الخاص بك.",
                "settings.webPushState.default": "اضغط على الزر لطلب الإذن وتسجيل الجهاز.",
                "settings.webPushState.unsupported": "هذا المتصفح لا يدعم دفع الإخطارات.",
                "settings.webPushVapidMissing": "VITE_VAPID_PUBLIC_KEY مفقود من إصدار الواجهة الأمامية هذا: لا يمكن إكمال اشتراك الدفع.",
                "tags.etiquetas": "التسميات",
                "tags.manageTitle": "إدارة العلامات",
                "tags.manage": "🏷️ العلامات",
                "tags.allTags": "جميع العلامات",
                "tags.confirmDelete": "هل تريد إزالة هذه العلامة؟",
                "tags.tagNamePlaceholder": "اسم العلامة",
                "tags.create": "يخلق",
                "tags.noTags": "لا توجد تسميات. إنشاء واحد أعلاه.",
                "tags.save": "يحفظ",
                "tags.edit": "يحرر",
                "tags.delete": "اِسْتَبْعَد",
                "tags.assignTo": "تعيين ل",
                "tags.noTagsToAssign": "لا توجد تصنيفات متاحة. قم بإنشائها أولاً.",
                "tags.bgColor": "لون الخلفية",
                "tags.textColor": "لون النص",
                "tags.selectTag": "حدد تصنيفًا",
                "templates.selectTitle": "قوالب",
                "templates.noTemplates": "لا توجد قوالب. إنشاء واحد أعلاه.",
                "templates.manage": "إدارة القوالب",
                "templates.confirmDelete": "هل تريد حذف هذا القالب؟",
                "templates.manageTitle": "إدارة القوالب",
                "templates.titlePlaceholder": "عنوان القالب",
                "templates.bodyPlaceholder": "لقد كتبت رسالة القالب...",
                "templates.create": "إنشاء قالب",
                "templates.save": "يحفظ",
                "templates.edit": "يحرر",
                "templates.delete": "اِسْتَبْعَد",
};

